export default {
  routes: {
    meeting: {
      badge: "Kostenlose Demo",
      heroTitleLine1: "Lass uns dein Angebot",
      heroTitleLine2: "live bringen.",
      heroDescription:
        "30 Minuten, unverbindlich. Wir zeigen dir App, Dashboard und Schließsysteme an deinem konkreten Anwendungsfall.",
      bullets: [
        "Live-Tour durch die Plattform",
        "Machbarkeit & Schließsystem-Check",
        "Individuelles Preisangebot",
      ],
      trustedBy: "Im Einsatz für",
    },
    team: {
      kicker: "Über uns",
      heroTitleLine1: "Wir machen Sharing",
      heroTitleLine2: "für alle möglich.",
      heroDescription:
        "JUHUU ist aus einer einfachen Idee entstanden: Eine App, über die man alles in seiner Umgebung finden, buchen und nutzen kann und eine Plattform, die das für Anbieter mühelos macht.",
      missionKicker: "Unsere Mission",
      missionTitle: "Die Sharing Economy neu denken.",
      missionText:
        "Wir integrieren und stärken bestehende Anbieter in Shared Mobility, Shared Infrastructure und Shared Tourism mit drastisch reduzierten Entwicklungskosten, weniger Wartung und schnellerem Markteintritt. Wir nehmen nicht nur an der Sharing Economy teil, wir gestalten sie.",
      valuesKicker: "Was uns antreibt",
      valuesTitle: "Klare Vision, echte Lösungen.",
      values: [
        {
          title: "Echte Probleme lösen",
          description:
            "Wir reden nicht nur über die Zukunft, WIR BAUEN SIE. Innovation, die im Alltag funktioniert.",
        },
        {
          title: "Partnerschaft",
          description:
            "Wir wollen kein Tool sein, sondern Partner. Mehr Kund:innen, weniger Aufwand, das ist JUHUU.",
        },
        {
          title: "Nachhaltigkeit",
          description:
            "Teilen statt besitzen. Wir helfen Menschen, sich nachhaltiger zu bewegen.",
        },
      ],
      awardTitle: "riz up GENIUS Award 2023",
      awardSubtitle: "Platz 1 — Kategorie \u201Eregional genial\u201C",
      awardText:
        "Ausgezeichnet für innovative Lösungen, die echte Probleme in einem dynamischen Markt lösen.",
      teamKicker: "Das Team",
      teamTitle: "Menschen hinter JUHUU.",
      members: [
        { initials: "BM", name: "Ben Müller-Niklas", role: "Gründer & CEO" },
        { initials: "MW", name: "Moritz Wallner", role: "Entwicklung & Technik" },
        { initials: "MM", name: "Marc Müller-Niklas", role: "Partnerschaften" },
        {
          initials: "MÜ",
          name: "Michael Übermasser",
          role: "Betrieb & Support",
        },
      ],
      locationKicker: "Standort",
      locationTitleLine1: "Aus Österreich,",
      locationTitleLine2: "für Europa.",
      locationText:
        "JUHUU entwickelt und betreibt die Plattform in Österreich, mit Daten auf EU-Servern und Fokus auf den europäischen Markt.",
      locationCta: "Lerne uns kennen",
      locationBadge: "🇦🇹 Österreich",
      finalCtaTitle: "Werde Teil der Sharing Economy.",
      finalCtaDescription:
        "Ob als Betreiber, Hersteller oder Partner lass uns gemeinsam etwas bewegen.",
      finalCtaButton: "Kontakt aufnehmen",
    },
    references: {
      kicker: "Referenzen",
      heroTitleLine1: "Betreiber, die mit",
      heroTitleLine2: "JUHUU arbeiten.",
      heroDescription:
        "Vom Bahnhof bis zum Bikeshop: Betreiber verschiedenster Größe steuern ihr Sharing -und Vermietungsgeschäft mit JUHUU.",
      stats: [
        { value: "20+", label: "aktive Betreiber" },
        { value: "< 1", label: "Monate bis live" },
        { value: "14+", label: "Sprachen" },
        { value: "24/7", label: "automatisierter Betrieb" },
      ],
      cases: [
        {
          org: "ÖBB-Personenverkehr AG",
          sub: "Bike:Parking",
          titleLine1: "Sicheres Fahrrad-Parken",
          titleLine2: "am Bahnhof automatisiert.",
          description:
            "Dutzende wettergeschützte Stellplätze und BikeBoxen, gebucht über die App und geöffnet per QR-Scan. Jahres-, Monats- und Tagestarife verwaltet das Team komplett über das JUHUU Dashboard.",
          stats: [
            { value: "50+", label: "Stellplätze" },
            { value: "24/7", label: "Zugang" },
            { value: "0", label: "Personal vor Ort" },
          ],
          quote:
            "\u201EUnsere Kund:innen buchen über die JUHUU App und öffnen den Fahrradraum per QR-Scan. Wir sehen jede Vermietung live im Dashboard, ganz ohne Personal vor Ort.\u201C",
          authorRole: "Projektleitung",
          authorOrg: "ÖBB Bike:Parking",
          authorInitials: "Ö",
        },
        {
          org: "Stadt Fellbach",
          sub: "Fahrradturm am Bahnhof",
          titleLine1: "Software-Übernahme",
          titleLine2: "für den BikeTower.",
          description:
            "Der 16 m hohe Fahrradturm parkt bis zu 76 Räder vollautomatisch. Die Steuersoftware kam ursprünglich vom Hersteller Koch & Partner. JUHUU hat sie übernommen und betreibt den Turm heute komplett: Buchung per App, Zugang per QR an einem von vier Toren, plus ÖPNV-Anbindung über die polygoCard.",
          stats: [
            { value: "76", label: "Stellplätze" },
            { value: "16 m", label: "Turmhöhe" },
            { value: "ÖPNV", label: "polygoCard-Anbindung" },
          ],
          quote:
            "\u201EUnser Fahrradturm lief jahrelang auf der Software des Herstellers. JUHUU hat die Steuerung komplett übernommen. Heute buchen Pendler:innen über die App, und ÖPNV-Abo-Kund:innen parken mit ihrer polygoCard kostenlos.\u201C",
          authorRole: "Stadt Fellbach",
          authorOrg: "Fellbach.go! radbox",
          authorInitials: "SF",
          transitLabel: "ÖPNV-Anbindung:",
          transitText:
            "Hinterlegte polygoCard (VVS) = kostenloses Parken für Abo-Kund:innen.",
        },
        {
          org: "Stadtwerke Osnabrück",
          sub: "Radstation Hauptbahnhof",
          titleLine1: "Ein weiterer Turm,",
          titleLine2: "zentral gesteuert.",
          description:
            "Auch am Osnabrücker Altstadtbahnhof steuert JUHUU einen automatischen Fahrradturm an und liefert sicheres Radparken ohne Personal vor Ort. Pendler:innen buchen über die App.",
          stats: [
            { value: "160", label: "Stellplätze" },
            { value: "24/7", label: "Zugang" },
          ],
          quote:
            "\u201EAm Bahnhof wollten wir sicheres Radparken ohne Personal. Mit JUHUU steuern wir den Turm zentral und sehen jede Buchung live.\u201C",
          authorRole: "Mobilitätsteam",
          authorOrg: "Stadtwerke Osnabrück",
          authorInitials: "OS",
        },
        {
          org: "Allgäutissimo Bikeshop",
          sub: "E-MTB-Verleih",
          titleLine1: "E-Bike-Verleih,",
          titleLine2: "der sich selbst verwaltet.",
          description:
            "Ein kleiner Bikeshop, der hochwertige E-MTBs über BikeBoxen verleiht. Mit dem JUHUU Dashboard verwaltet das Team Vermietungen, Tarife und Kautionen. Und das ganz ohne eigenem IT-Team.",
          stats: [
            { value: "+69%", label: "Umsatz-Trend" },
            { value: "7", label: "aktive Tarife" },
            { value: "4", label: "BikeBoxen" },
          ],
          quote:
            "\u201EWir vermieten E-MTBs über mehrere BikeBoxen. Tarife, Buchungen und Abrechnung laufen automatisch. Wir kümmern uns ums Rad, nicht um die Software.\u201C",
          authorRole: "Thorsten Schmitt",
          authorOrg: "Inhaber Allgäutissimo Bikeshop",
          authorInitials: "AB",
        },
      ],
      moreKicker: "Mehr Betreiber",
      moreTitle: "In guter Gesellschaft.",
      more: [
        {
          name: "Stadt Korneuburg",
          type: "Gemeinde",
          description:
            "Digitale Mobilitäts-Infrastruktur für Bürger:innen Fahrrad-Parken und mehr in einer App.",
        },
        {
          name: "Bike.Box",
          type: "Hardware-Partner",
          description:
            "Sichere, nachrüstbare Fahrradboxen, die über JUHUU buchbar und steuerbar sind.",
        },
        {
          name: "NÖ.Regional",
          type: "Regionalentwicklung",
          description:
            "Regionale Sharing-Projekte, gebündelt in einer Plattform statt vieler Insellösungen.",
        },
      ],
      finalCtaTitle: "Werde der nächste Betreiber.",
      finalCtaDescription:
        "In einer kostenlosen Demo zeigen wir dir, wie dein Geschäft mit JUHUU läuft.",
      finalCtaButton: "Demo buchen",
    },
    industries: {
      kicker: "Branchen",
      heroTitleLine1: "Dein Angebot.",
      heroTitleLine2: "Unsere Plattform.",
      heroDescription:
        "Ob sichere Fahrrad-Stellplätze oder ein kompletter Verleih. JUHUU bringt dein Angebot in die App und steuert es über ein Dashboard. Wenn dein Fall besonders ist, bauen wir ihn gemeinsam.",
      chipParking: "Fahrradparken",
      chipRental: "Bike Rental",
      chipCustom: "Sonstige UseCases",
      parkingTitle: "Fahrradparken",
      parkingDescription:
        "BikeBoxen und sichere Abstellräume am Bahnhof, im Stadtzentrum oder am Arbeitsplatz. Automatisiert vermietet, geöffnet per QR-Scan. Ganz ohne Personal vor Ort.",
      parkingBullets: [
        "Tages-, Monats- oder Langzeitmiete",
        "Nachrüstbare Schließsysteme",
        "Auslastung live im Dashboard",
      ],
      parkingStatValue: "50+",
      parkingStatLabel: "sichere Stellplätze (ÖBB Bike:Parking)",
      parkingStatNote:
        "Wettergeschützt, videoüberwacht, diebstahlsicher geöffnet per Knopfdruck über die App.",
      rentalTitle: "Bike Rental",
      rentalDescription:
        "Vom einzelnen Bikeshop bis zur Flotte: Fahrräder und E-Bikes flexibel verleihen. Self-Service rund um die Uhr, mit genauer Abrechnung.",
      rentalBullets: [
        "Pay-as-you-go, Tages- & Mehrtagestarife",
        "Übergabe per QR-Scan oder BikeBox",
        "Eigenes Branding in der App",
      ],
      rentalStatValue: "+69%",
      rentalStatLabel: "Umsatz-Trend (Allgäutissimo Bikeshop)",
      rentalStatNote:
        "E-MTBs über mehrere BikeBoxen vermietet. Tarife, Buchungen und Abrechnung laufen automatisch.",
      customBadge: "Dein eigener UseCase",
      customTitleLine1: "Dein Angebot passt",
      customTitleLine2: "in keine Schublade?",
      customDescription:
        "JUHUU ist modular. Fast jedes smarte Gerät oder jeder Service lässt sich anbinden — von Lade-Infrastruktur über Schließfächer bis zu Equipment-Verleih. Wir bauen deinen UseCase gemeinsam mit dir, statt dich in ein Standard-Produkt zu zwängen.",
      customCta: "UseCase besprechen",
      customTiles: [
        "Lade-Infrastruktur",
        "Schließfächer",
        "Equipment-Verleih",
        "Dein UseCase",
      ],
      finalCtaTitle: "Lass uns über deinen Fall sprechen.",
      finalCtaDescription:
        "In einer kostenlosen Demo zeigen wir dir, wie dein Angebot mit JUHUU live geht.",
      finalCtaButton: "Demo buchen",
    },
    lockingSystems: {
      heroBadge: "Schließsysteme · Hardware",
      heroTitleLine1: "Infrastruktur,",
      heroTitleHighlight: "über die App",
      heroTitleSuffix: "gesteuert.",
      heroDescription:
        "Das Schließsystem ist die Brücke zwischen JUHUU und der realen Welt: Vom autarken Schloss über das vernetzte Control Kit und die JUHUU Cloud bis zur App, mit der Nutzer:innen entsperren.",
      ctaAdvice: "Beratung anfragen",
      ctaSeeKits: "Die Kits ansehen",
      diagramAlt:
        "JUHUU Schließsystem — von der Schließeinheit über das Control Kit und die JUHUU Cloud bis zur App",
      sysNodes: [
        {
          title: "Schließeinheit",
          description:
            "Das Schloss vor Ort, autark wie Tapkey oder über das Relay Kit angesteuert.",
        },
        {
          title: "Control Kit",
          description:
            "Strom, Internetverbindung & Steuereinheit. Das vernetzte Herzstück am Standort.",
        },
        {
          title: "JUHUU Cloud",
          description:
            "Sichere Steuerung in Echtzeit, jede Aktion wird protokolliert und im Dashboard sichtbar.",
        },
        {
          title: "App & WebApp",
          description: "Nutzer:innen entsperren per App, WebApp, Karte oder Terminal.",
        },
      ],
      explainerKicker: "Wofür Schließsysteme da sind",
      explainerTitleLine1: "Software trifft",
      explainerTitleLine2: "physische Hardware.",
      explainerLead:
        "Über das Schließsystem verbindet JUHUU die App mit echten Geräten vor Ort. Du legst Tarife und Zugänge im Dashboard fest. Entsperrt und gesteuert wird in Echtzeit.",
      explainerCards: [
        {
          title: "Standardlösungen",
          description:
            "Für gängige Schließmechanismen wie Schiebetüren, Boxen, Schränke haben wir fertige Kits, die sofort einsatzbereit sind.",
        },
        {
          title: "Relay Kit für Sonderfälle",
          description:
            "Alles, was speziell angesteuert werden soll, wird zusätzlich über das Relay Kit am Control Kit nahezu jedes Gerät angesteuert.",
        },
        {
          title: "App & WebApp Steuerung",
          description:
            "Endnutzer:innen entsperren per App oder WebApp. Du behältst jede Aktion live im JUHUU Dashboard im Blick.",
        },
      ],
      kitsKicker: "Unsere Kits",
      kitsTitle: "Ein Kit für jeden Anwendungsfall.",
      labelUseCase: "UseCase",
      labelPlugAndPlay: "Plug & Play",
      plugAndPlayText:
        "In der Standardausführung sofort einsatzbereit. Anschließen und loslegen.",
      kits: [
        {
          badge: "Autark",
          index: "01 — Tapkey",
          title: "Tapkey Schloss",
          description:
            "Der elektronische Schließzylinder, der völlig eigenständig läuft. Batteriebetrieben und ohne Verkabelung. Einfach den bestehenden Zylinder tauschen und per App, NFC-Karte oder Tag entsperren.",
          useCase:
            "Türen zu Fahrradräumen, Sammelgaragen, Lager- und Technikräume oder bereits bestehende BikeBoxen. Also überall, wo keine Verkabelung möglich ist und das Schloss eigenständig laufen muss.",
          specs: [
            { k: "Typ", v: "Elektronischer Schließzylinder (Europrofil)" },
            { k: "Betrieb", v: "Autark, batteriebetrieben" },
            { k: "Stromversorgung", v: "2× Lithium CR2, 3,0 V" },
            { k: "Batterielebensdauer", v: "bis 25.000 Schließzyklen / 3 Jahre" },
            { k: "Baulängen", v: "40–100 mm (bis 180 mm auf Anfrage)" },
            { k: "Dauerfestigkeit", v: "≥ 100.000 Zyklen (EN 15684 Kl. 6)" },
            { k: "Schutzart", v: "IP66 Außenknauf · IP65 Zylinder" },
            { k: "Temperatur", v: "−25 °C … +65 °C" },
            { k: "Zugang", v: "NFC 13,56 MHz · MIFARE DESFire EV2 (AES-128)" },
            { k: "Bedienung", v: "Android (BLE & NFC) · iPhone (BLE)" },
            { k: "Zertifizierung", v: "EN 15684 · Feuerwiderstand T90" },
          ],
        },
        {
          badge: "Steuereinheit",
          index: "02 — Control Kit",
          title: "Control Kit",
          description:
            "Das vernetzte Herzstück: Es stellt die Internetverbindung her, hängt am Strom und trägt die Steuereinheit. Von hier steuert JUHUU in Echtzeit aus der Cloud — und an das Control Kit werden die Relay Kits angeschlossen.",
          useCase:
            "Das Rückgrat jeder vernetzten Anlage. Überall, wo ein Standort online gesteuert wird. Es versorgt die Relay Kits und meldet jede Aktion an die JUHUU Cloud.",
          specs: [
            { k: "Typ", v: "Steuereinheit / Gateway" },
            { k: "Funktion", v: "Internetanbindung & Steuerung" },
            { k: "Verbindung", v: "Mobilfunk (LTE/NB-IoT) · WLAN · Bluetooth" },
            { k: "Stromversorgung", v: "12–24 V DC (Netzbetrieb)" },
            { k: "Steuerung", v: "JUHUU Cloud & Dashboard, Echtzeit" },
            { k: "Erweiterung", v: "Relay Kits anschließbar" },
            { k: "Einsatz", v: "Eine Einheit je Standort" },
          ],
        },
        {
          badge: "Relay",
          index: "03 — Relay Kit",
          title: "Relay Kit",
          description:
            "Das Schalt-Kit am Control Kit: Es steuert Schlösser oder alles, was sich über ein Relais ansteuern lässt. 8 Leistungsrelais pro Kit, für große Anlagen einfach kaskadierbar.",
          useCase:
            "Steuert Schlösser, Schranken, Motoren, Lichter und Sonderhardware. Alles, was sich über ein Relais schalten lässt.",
          specs: [
            { k: "Typ", v: "Relais-Schaltkit" },
            { k: "Stromversorgung", v: "12–24 V DC (rot +, schwarz −)" },
            { k: "Relaiskanäle", v: "8 × mit Optokopplern & Schutzschaltung" },
            { k: "Relaismodule", v: "8 × Leistungsrelais" },
            { k: "Anschlüsse", v: "Schraubklemmen · NO/COM/NC · Data/GND" },
            { k: "Verbindung", v: "an Control Kit, kaskadierbar" },
            { k: "Gehäuse", v: "Kunststoff mit Dichtung, IP65" },
            { k: "Montage", v: "Montageplatte, Zugentlastung, Kabelsatz" },
          ],
        },
        {
          badge: "Autark · elektronisch",
          index: "04 — EMZ",
          title: "EMZ Elektronik-Kit",
          description:
            "Ein komplett eigenständiges Kit mit eigenen elektronischen Schlössern motorisch verriegelt, also kein manuelles Drehen wie beim Zylinder. Die autarke Alternative zu Tapkey, wenn du elektrische Schlösser brauchst: wasserfest, wetterfest und bis zu 2 Jahre Akkulaufzeit.",
          useCase:
            "BikeBoxen und Anlagen, die eine autarke, elektrische Verriegelung brauchen, ohne Verkabelung und ohne manuelles Schließen.",
          specs: [
            { k: "Typ", v: "Eigenständiges Kit mit elektronischen Schlössern" },
            { k: "Schloss", v: "Motorisch verriegelt (kein manuelles Drehen)" },
            { k: "Betrieb", v: "Autark, batteriebetrieben" },
            { k: "Akkulaufzeit", v: "bis zu 2 Jahre" },
            { k: "Schutz", v: "Wasserfest & wetterfest" },
            { k: "Zugang", v: "App · NFC" },
            { k: "Steuerung", v: "In JUHUU integriert" },
          ],
        },
      ],
      accessoriesKicker: "Zubehör & Zusatzlösungen",
      accessoriesTitle: "Mehr als das Schloss.",
      accessoriesLead:
        "Rund um die Kits bieten wir die Hardware, die ein professioneller Standort braucht. Von der Terminallösung vor Ort bis zur Sensorik.",
      accessories: [
        {
          title: "Terminal vor Ort",
          description:
            "Eine wetterfeste Self-Service-Säule für alle, die ohne Smartphone buchen wollen: Stellplatz oder Box am Touchscreen wählen, kontaktlos zahlen (Karte, Apple Pay, Google Pay) und direkt entsperren. Angebunden an dasselbe JUHUU Dashboard wie App und WebApp.",
        },
        {
          title: "Strom- & Solarversorgung",
          description:
            "Netzteile, Akku-Puffer und Solar-Optionen für Standorte ohne festen Stromanschluss, damit Control- und Relay-Kit auch netzfern zuverlässig laufen.",
        },
        {
          title: "RFID- & Kartenleser",
          description:
            "Zugang per NFC-/RFID-Karte für ÖPNV-Karten, Mitarbeiter:innen-Ausweise oder ausgegebene Tags. Ideal als Alternative zum Smartphone an stark frequentierten Standorten.",
        },
        {
          title: "Belegungs-Sensorik",
          description:
            "Sensoren erkennen, ob eine Box oder ein Stellplatz frei oder belegt ist und die Verfügbarkeit erscheint live in App, WebApp und Dashboard.",
        },
      ],
      dailyKicker: "Gemacht für den Alltag",
      dailyTitleLine1: "Robust, nachrüstbar,",
      dailyTitleLine2: "wartungsarm.",
      dailyDescription:
        "Unsere Schließsysteme sind für den Dauereinsatz gebaut und lassen sich an Bestandshardware nachrüsten, ohne teuren Austausch.",
      dailyBullets: [
        "App-, WebApp-und Kartenzugang",
        "Nachrüstbar an Türen, Boxen & Schiebetüren",
        "Wetterfeste Komponenten für den Außeneinsatz",
        "Zentral im JUHUU Dashboard steuerbar & protokolliert",
      ],
      dailyPhotoPlaceholder: "Foto vom Einsatz vor Ort ablegen",
      dailyPhotoAlt: "JUHUU Schließsysteme im Alltagseinsatz vor Ort",
      finalCtaTitle: "Passt das zu deiner Hardware?",
      finalCtaDescription:
        "Schick uns deinen Anwendungsfall und wir prüfen die Nachrüstbarkeit und empfehlen dir das passende Kit.",
      finalCtaButton: "Beratung anfragen",
    },
    home: {
      page: {
        heroBadge: "All-in-One Sharing-Plattform",
        heroTitle: "Die Plattform für moderne",
        heroHighlight: "Mobilität & Infrastruktur",
        heroDescription:
          "Wir digitalisieren deine Infrastruktur. Verbinde dein smartes Gerät, biete es in der JUHUU App an und steuere alles über unser Dashboard.",
        heroCtaDemo: "Demo buchen",
        heroCtaProducts: "Produkte ansehen",
        heroChecks: [
          "Plug & Play Hardware",
          "Interface & Tarife von uns eingerichtet",
          "Startklar out of the box",
        ],
        trustedBy: "Im Einsatz für",
        offerKicker: "Das Angebot",
        offerTitleLine1: "Ein Toolkit.",
        offerTitleLine2: "Für Städte und Hersteller.",
        offerDescription:
          "App, WebApp, Buchungsplattform, Gerätesteuerung und die passende Elektronik aus einer Hand. Das komplette Toolkit, damit deine Infrastruktur digital wird.",
        citiesKicker: "Städte · Kommunen · Öffentliche Hand",
        citiesTitle: "Digitale Services für deine Bürger:innen.",
        citiesDescription:
          "Wir liefern App, WebApp und Buchungsplattform, Gerätesteuerung und passender Elektronik inklusive. Damit bringst du Fahrradparken, Rental und Shared Mobility live, aber auch jeden anderen Prozess, bei dem deine Bürger:innen etwas finden, buchen und steuern.",
        citiesBullets: [
          "App, WebApp & Buchungsplattform aus einer Hand",
          "Gerätesteuerung & passende Elektronik inklusive",
          "Fahrradparken, Rental, Shared Mobility & mehr",
          "Auch für Bike- & Scootersharing ganz ohne physische Stationen",
        ],
        manufacturersKicker: "Hardware-Hersteller",
        manufacturersTitle: "Deine Hardware mit JUHUU Software",
        manufacturersDescription:
          "Zwei Wege, deine Geräte buchbar und steuerbar zu machen:",
        manufacturersOptionATitle: "Direkt in der JUHUU App",
        manufacturersOptionADescription:
          "Bring deine Geräte in die JUHUU App und verkaufe die Software einfach mit, sofort sichtbar für alle bestehenden Nutzer:innen.",
        manufacturersOptionBTitle: "Komplette Whitelabel-Lösung",
        manufacturersOptionBDescription:
          "Erhalte eine fertige Whitelabel-Lösung mit deiner angebundenen Hardware, JUHUU läuft nur im Hintergrund. Verkaufe sie unter deiner Marke weiter, ideal für Ausschreibungen.",
        productsKicker: "Drei Bausteine für erstklassige Infrastruktur",
        productsTitle: "App - Dashboard - Schließsysteme",
        productsLead:
          "Vom physischen Gerät bis zur Buchung in der App. JUHUU deckt den gesamten Prozess ab.",
        appDeployCells: [
          {
            tag: "Ohne Installation",
            title: "WebApp",
            description:
              "Dieselbe Funktionalität direkt im Browser, ideal für QR-Einstieg vor Ort, ganz ohne Download aus dem Store.",
          },
          {
            tag: "In der JUHUU App",
            title: "JUHUU-App",
            description:
              "Dein Bereich erscheint in der JUHUU App. Mit deinen Farben, Wording, Logo & Map-Marker. Sofort sichtbar für bestehende Nutzer:innen.",
          },
          {
            tag: "Eigene App",
            title: "Whitelabel App",
            description:
              "Eine komplett eigene App in deinem Look: App-Icon, Ladescreen, Karte, Buttons und gesamtes Erscheinungsbild unter deiner Marke.",
          },
        ],
        payStripKicker: "Alle gängigen Zahlungsmittel · über Stripe",
        includedKicker: "In jeder Variante dabei",
        includedItems: [
          "Im Gast-Modus ohne Account die App entdecken",
          "Optionaler Identitätsnachweis (Ausweis / Führerschein)",
          "14+ Sprachen",
        ],
        dashboardTitleAlt1: "Dein Geschäft",
        dashboardTitleAlt2: "im Überblick.",
        dashboardLead:
          "Geräte verwalten, Tarife anlegen, Abrechnung automatisieren und in Echtzeit sehen, was läuft. Vorausschauende Wartung und Analytik inklusive, ohne eigenes Tech-Team.",
        dashboardBullets: [
          "Echtzeit-Monitoring aller Geräte & Standorte",
          "Tarife frei konfigurierbar, sekundengenaue Abrechnung",
          "Automatische Rechnungen direkt in deine Buchhaltung",
          "Eigenes Branding: Logo & Farben in der App",
        ],
        dashboardChips: [
          "Buchungen",
          "Geräte",
          "Tarife",
          "Abrechnung",
          "Kund:innen",
          "Benefit Cards",
          "Vorfälle",
        ],
        dashboardCta: "Dashboard ansehen",
        hardwareSpecs: [
          ["IP66", "3 Jahre Akku", "NFC · BLE", "EN 15684"],
          ["LTE · WLAN · BLE", "12–24 V DC", "Echtzeit"],
          ["8 Relais", "IP65", "NO/COM/NC"],
          ["Motorisch", "bis 2 J. Akku", "Wasserfest"],
        ],
        appKicker: "JUHUU App",
        appTitleLine1: "Eine App.",
        appTitleLine2: "Alles, was die Stadt teilt.",
        appDescription:
          "Endnutzer:innen entdecken, buchen und entsperren Geräte verschiedenster Anbieter, in einer einzigen, intuitiven App. Ohne viele Hürden, mit transparenten Preisen und sicherer Bezahlung.",
        appBullets: [
          "Gast-Modus: Alle Angebote ohne Account finden",
          "QR-Code scannen um in Sekunden einen Service zu nutzen",
          "Shared Mobility, Infrastruktur & Tourismus in einer Plattform",
          "14+ Sprachen, immer eine sichere Zahlung",
        ],
        appCta: "JUHUU App entdecken",
        dashboardKicker: "JUHUU Dashboard",
        dashboardTitleLine1: "Dashboard.",
        dashboardTitleLine2: "Das passiert gerade in deinem Geschäft.",
        dashboardNavHome: "Home",
        dashboardNavOperators: "Operators",
        dashboardNavBooking: "Buchungen",
        dashboardNavDevices: "Geräte",
        dashboardNavBilling: "Abrechnung",
        dashboardNavSupport: "Support",
        dashboardKpis: [
          { label: "Umsatz (7 T.)", value: "3.000 €", delta: "▲ 69,4 %" },
          { label: "Vermietungen", value: "12", delta: "▲ 33,3 %" },
          { label: "Aktive Geräte", value: "318", delta: "6 offline" },
          { label: "Auslastung", value: "74 %", delta: "Ø 7 Tage" },
        ],
        dashboardIncidents: "Offene Vorfälle",
        dashboardIncidentAwaiting: "Bestätigung offen",
        lockingKicker: "Schließsysteme",
        lockingTagPill: "Hardware",
        lockingTitleLine1: "Smarte Schlösser,",
        lockingTitleLine2: "die einfach funktionieren.",
        lockingDescription:
          "Vom Fahrradraum bis zur BikeBox: JUHUU-Schließsysteme verbinden die physische Welt mit der App. QR scannen, entsperren, loslegen. Kabellos, wetterfest und für Bestandshardware nachrüstbar.",
        lockingBullets: [
          "QR- & Bluetooth-Zugang, auch offline",
          "Nachrüstbar, keine neue Infrastruktur notwendig",
          "Wetterfest, videoüberwacht, diebstahlsicher",
          "Zentral steuerbar über das Dashboard",
        ],
        lockingCta: "Schließsysteme entdecken",
        hardwareItems: [
          {
            name: "Tapkey",
            tag: "Autark",
            title: "Elektronischer Schließzylinder",
            description:
              "Läuft völlig eigenständig, batteriebetrieben, ohne Verkabelung. Bestehenden Zylinder tauschen und per App, NFC-Karte oder Tag entsperren.",
          },
          {
            name: "Control Kit",
            tag: "Steuereinheit",
            title: "Strom, Internet & Steuerung",
            description:
              "Das vernetzte Herzstück: stellt die Internetverbindung her, hängt am Strom und steuert in Echtzeit aus der Cloud. Hier werden die Relay Kits angeschlossen.",
          },
          {
            name: "Relay Kit",
            tag: "Relay",
            title: "Schaltet (fast) alles",
            description:
              "Das Schalt-Kit am Control Kit: steuert Schlösser, Schranken, Motoren, Lichter und Sonderhardware — alles, was sich über ein Relais schalten lässt. Für große Anlagen kaskadierbar.",
          },
          {
            name: "EMZ",
            tag: "Autark · elektronisch",
            title: "Eigene elektronische Schlösser",
            description:
              "Ein eigenständiges Kit mit motorisch verriegelten Schlössern — kein manuelles Drehen. Die autarke Alternative zu Tapkey für elektrische Schlösser: wasserfest und bis zu 2 Jahre Akkulaufzeit.",
          },
        ],
        stepsKicker: "So einfach ist es",
        stepsTitleLine1: "Plug & Play",
        stepsTitleLine2: "Startklar in 4 Schritten.",
        stepsDescription:
          "Du kaufst das Schließsystem bei uns, den Rest übernehmen wir. Beratung, Einrichtung und Tarife inklusive, damit du ohne eigenes Tech-Team starten kannst.",
        steps: [
          {
            title: "Beratung",
            description:
              "Wir analysieren deinen Use Case und empfehlen das passende Schließsystem für deinen Standort.",
          },
          {
            title: "Plug & Play Hardware",
            description:
              "Du erhältst Schließsystem und Hardware vorkonfiguriert. Einfach anschließen und fertig, ganz ohne Entwicklung.",
          },
          {
            title: "Wir richten alles ein",
            description:
              "Interface, Branding und Tarife konfigurieren wir für dich im Dashboard, abgestimmt auf dein Angebot.",
          },
          {
            title: "Ready to go",
            description:
              "Dein Angebot ist live in App, WebApp & Dashboard — deine Kund:innen buchen und verwenden es einfach.",
          },
        ],
        industriesKicker: "Für wen wir bauen",
        industriesTitle: "Deine Branche. Unsere Plattform.",
        industries: [
          {
            title: "Fahrradparken",
            description: "BikeBoxen & sichere Abstellräume am Bahnhof.",
          },
          {
            title: "Bike Rental",
            description: "Fahrräder & E-Bikes flexibel verleihen, rund um die Uhr.",
          },
          {
            title: "Sonstige UseCases",
            description: "Dein Anwendungsfall ist besonders? Wir bauen ihn.",
          },
        ],
        pricingKicker: "Preise",
        pricingTitleLine1: "Enterprise-Qualität.",
        pricingTitleLine2: "Für jede Größe.",
        pricingDescription:
          "Eine Plattform, die mit dir wächst, ob ein Standort oder ein landesweites Netzwerk. Du zahlst nur für das, was du nutzt.",
        pricingPoints: [
          "Monatlich kündbar",
          "Keine Setup-Gebühr für Standard-Integrationen",
          "Mitwachsende Provision statt Fixkostenfalle",
        ],
        pricingCardLabel: "App + Dashboard + Schließsysteme",
        pricingFrom: "ab €149",
        pricingPeriod: "/Monat für 50 Stellplätze",
        pricingNote:
          "+ faire Provision pro Buchung. Skaliert mit deinem Geschäft.",
        pricingIncludes: [
          "Sichtbarkeit in der JUHUU App",
          "Volles Dashboard mit Analytics",
          "Automatische Abrechnung & Rechnungen",
          "Eigenes Branding & Custom Interface",
        ],
        pricingCta: "Angebot anfragen",
        pricingBadges: ["Monatlich kündbar", "DSGVO-konform", "EU-Server"],
        faqKicker: "FAQ",
        faqTitle: "Häufige Fragen.",
        faqs: [
          {
            q: "Was genau ist JUHUU?",
            a: "JUHUU ist eine modulare All-in-One Plattform für die Sharing Economy. Wir liefern den kompletten Software-Stack — App, Dashboard, Abrechnung, Support — plus smarte Schließsysteme, damit du jedes Gerät oder jeden Service in Tagen statt Monaten anbieten kannst.",
          },
          {
            q: "Muss ich eine eigene App entwickeln?",
            a: "Nein. Dein Angebot erscheint direkt in der JUHUU App und wird sofort für alle bestehenden Nutzer:innen sichtbar. Auf Wunsch mit deinem eigenen Branding und Custom Interface.",
          },
          {
            q: "Wie lange dauert die Integration?",
            a: "In der Regel unter zwei Monate. Über No-Code-Vorlagen, Low-Code-Konfiguratoren oder unsere API binden wir Geräte verschiedenster Hersteller an — ohne dass du eigene Entwicklung brauchst.",
          },
          {
            q: "Funktionieren eure Schließsysteme mit meiner Hardware?",
            a: "In den meisten Fällen ja. JUHUU-Schließsysteme sind nachrüstbar und für gängige Türen, Boxen und Schränke ausgelegt. Im Demo-Gespräch prüfen wir deinen konkreten Fall.",
          },
          {
            q: "Wie funktioniert die Abrechnung?",
            a: "Vollautomatisch. Tarife legst du im Dashboard fest, JUHUU übernimmt Zahlung und Rechnungsstellung und kann diese direkt in dein Buchhaltungssystem einspielen.",
          },
          {
            q: "Ist JUHUU DSGVO-konform?",
            a: "Ja. Alle Daten werden auf EU-Servern verarbeitet, und wir halten die DSGVO ein. Details klären wir gerne im Gespräch.",
          },
        ],
        finalCtaTitle: "Bereit, dein Gerät online zu bringen?",
        finalCtaDescription:
          "In einer kostenlosen Demo zeigen wir dir, wie schnell dein Angebot in der JUHUU App live geht.",
        finalCtaButton: "Kostenlose Demo buchen",
        finalStats: [
          { value: "< 2", label: "Monate", sub: "bis live" },
          { value: "DSGVO", label: "EU-Server", sub: "" },
        ],
      },
      heroTitle: "Die Plattform für moderne",
      heroHighlight: "Mobilität & Infrastruktur",
      heroDescription:
        "JUHUU ist eine modulare Plattform, die Unternehmen dabei hilft, digitale Lösungen für geteilte Mobilität, intelligente Infrastruktur und Versorgungsunternehmen aufzubauen, zu starten und zu skalieren – alles an einem Ort.",
      getStarted: "Jetzt starten",
      fastDeployment: "Schnelle Bereitstellung",
      modularDesign: "Modulares Design",
      aiEnhanced: "KI-unterstützt",
      productCategoriesTitle: "Unsere Produktkategorien",
      productCategoriesDescription:
        "Entdecken Sie unsere umfassende Suite an Lösungen, die auf Ihre Geschäftsbedürfnisse zugeschnitten sind",
      emailPlaceholder: "E-Mail-Adresse",
      dashboardAlt: "JUHUU Dashboard",
      components: {
        useCases: {
          title: "Lösungen für jeden Bedarf",
          description:
            "Entdecken Sie, wie JUHUU sich an verschiedene Branchen und Anwendungsfälle anpasst",
          designModel: {
            title: "Geschäftsmodell gestalten",
            description:
              "JUHUU stellt OEMs und Betreibern ein umfassendes Toolkit zur Verfügung, um eigene Geschäftsmodelle zu entwickeln...",
            tags: [
              "Modulare Bausteine",
              "Flexible Integration",
              "Individuelle Erlösmodelle",
              "Schnelle Implementierung",
            ],
            cta: "Möglichkeiten entdecken",
            imgAlt: "Individuelles Geschäftsmodell",
          },
          bikeParking: {
            title: "Fahrradparken",
            description:
              "Unsere umfassende Fahrradpark-Lösung dient sowohl OEMs als auch Betreibern...",
            tags: [
              "Hardware-Integration",
              "Zugangsverwaltung",
              "Nutzungsanalysen",
              "Abo-Modelle",
            ],
            cta: "Fahrradparken entdecken",
            imgAlt: "Fahrradpark-Lösung",
          },
          smartCity: {
            title: "Smart City",
            description:
              "JUHUU stattet Städte mit einem umfassenden Toolkit aus, um Smart Cities zu werden und alle Dienste auf einer zentralen Plattform zu integrieren",
            tags: ["Flottenmanagement", "Benutzer-Apps", "Wartung", "Analysen"],
            cta: "Smart City entdecken",
            imgAlt: "Bike Sharing",
          },
        },
        targetGroups: {
          title: "Stärkung Ihres digitalen Ökosystems",
          description:
            "Unsere modulare SaaS-Plattform bietet maßgeschneiderte Lösungen für verschiedene Akteure im Bereich Mobilität und Infrastruktur",
          oems: {
            title: "Für OEMs",
            description:
              "Integrieren Sie Ihre Hardware in unser Ökosystem und erweitern Sie Ihre Marktpräsenz. Unsere Plattform bietet Werkzeuge, um Ihre Produkte zu digitalisieren, die Leistung zu überwachen und neue Einnahmequellen zu erschließen.",
            features: {
              digitalTwins: {
                title: "Digitale Zwillinge",
                desc: "Erstellen Sie virtuelle Abbilder Ihrer Hardware",
              },
              integrationOptions: {
                title: "Integrationsoptionen",
                desc: "No-Code-, Low-Code- und Expertenlösungen",
              },
              marketplace: {
                title: "Marktplatz",
                desc: "Präsentieren Sie Ihre Produkte Betreibern",
              },
              analytics: {
                title: "Analysen",
                desc: "Gewinnen Sie Erkenntnisse aus Nutzungsdaten",
              },
            },
            imageAlt: "OEM-Geräte",
          },
          operators: {
            title: "Für Betreiber",
            description:
              "Bauen Sie Ihre digitalen Geschäftsmodelle schnell auf, starten Sie sie und skalieren Sie sie mit unseren modularen Bausteinen. Erstellen Sie maßgeschneiderte Lösungen für Shared Mobility, smarte Infrastruktur und Versorgungsbetriebe, ohne bei null zu beginnen.",
            features: {
              modularPlatform: {
                title: "Modulare Plattform",
                desc: "Kombinieren Sie Komponenten nach Bedarf",
              },
              dashboard: {
                title: "Dashboard",
                desc: "Überwachen und verwalten Sie Ihre Abläufe",
              },
              billing: {
                title: "Abrechnung",
                desc: "Zahlungen und Abonnements abwickeln",
              },
              userApps: {
                title: "Benutzer-Apps",
                desc: "Nahtlose Kundenerlebnisse bieten",
              },
            },
            imageAlt: "Operator-Dashboard",
          },
        },
        //   coreInfrastructure: {
        //     tag: "Kerninfrastruktur & Entwicklerwerkzeuge",
        //     title: "Grundlage für Innovation schaffen",
        //     description:
        //       "Diese Kategorie bildet das Rückgrat des JUHUU-Ökosystems und stellt die notwendige Infrastruktur und Entwicklerwerkzeuge bereit, um schnelle Entwicklung, sichere Integration und skalierbare Abläufe für Shared Mobility und smarte Infrastruktur zu ermöglichen. Betreiber und OEMs erhalten so eine solide Basis, um effizient Innovationen umzusetzen.",
        //     identity: {
        //       title: "JUHUU Identity",
        //       description:
        //         "Zentraler Authentifizierungsdienst mit E-Mail/Passwort, Google-/Apple-Login und optionaler Ausweisprüfung.",
        //       cta: "Identity-Lösungen",
        //       alt: "JUHUU Identity",
        //     },
        //     docs: {
        //       title: "JUHUU Docs",
        //       description:
        //         "Umfassende Wissensdatenbank, in der OEMs und Betreiber Handbücher, technische Daten und Richtlinien hinterlegen.",
        //       cta: "Dokumentations-Hub",
        //       alt: "JUHUU Docs",
        //     },
        //     specialDevelopment: {
        //       title: "JUHUU Sonderentwicklung",
        //       description:
        //         "Maßgeschneiderter Integrationsservice für komplexe Anwendungsfälle mit individuell eingebetteten Systemen.",
        //       cta: "Individuelle Lösungen",
        //       alt: "JUHUU Sonderentwicklung",
        //     },
        //     digitalTwins: {
        //       title: "JUHUU Digital Twins",
        //       description:
        //         "Ein zentraler Hub, der virtuelle Zwillinge integrierter Geräte erstellt und Betreibern die Überwachung von Zustand und Status ermöglicht.",
        //       cta: "Digital-Twin-Plattform",
        //       alt: "JUHUU Digital Twins",
        //     },
        //     developerToolsLabel: "Developer Tools",
        //     bigImageAlt: "Kerninfrastruktur & Entwicklerwerkzeuge",
        //   },
        //   userAccess: {
        //     tag: "Zugangs- & Buchungsoberflächen",
        //     title: "Nahtloser Zugang jederzeit",
        //     description:
        //       "Diese Kategorie liefert benutzerfreundliche Oberflächen, die Buchung und Zugang zu Mobilitäts- und Infrastrukturdiensten über mehrere Plattformen hinweg vereinfachen.",
        //     app: {
        //       title: "JUHUU App",
        //       description:
        //         "Native iOS/Android-App, mit der Nutzer Dienste wie Bikes, Scooter und Schließfächer über eine einzige Oberfläche finden, buchen und nutzen können – inklusive White-Label-Optionen für Betreiber.",
        //       cta: "App-Funktionen",
        //       label: "Mobile App",
        //       altIcon: "JUHUU App",
        //       altImage: "JUHUU Mobile App",
        //       appStoreAlt: "Im App Store laden",
        //       googlePlayAlt: "Bei Google Play holen",
        //     },
        //     webApp: {
        //       title: "JUHUU Web App",
        //       description:
        //         "Browserbasierte Alternative zur JUHUU App mit vollständiger Buchungs- und Öffnungsfunktion für Gelegenheitsnutzer und reduziertem Funktionsumfang zur Förderung der nativen App.",
        //       cta: "Web-App-Plattform",
        //       altIcon: "JUHUU Web App",
        //     },
        //     map: {
        //       title: "JUHUU Map",
        //       description:
        //         "Interaktive Karte mit allen Standorten, anpassbaren Filtern und Betreiberbranding sowie Iframe-Einbindung für externe Plattformen gegen Aufpreis.",
        //       cta: "Interaktive Karte",
        //       altIcon: "JUHUU Map",
        //     },
        //   },
        //   commerce: {
        //     tag: "Commerce & Monetarisierung",
        //     title: "Transaktionen in Wachstum verwandeln",
        //     description:
        //       "Leistungsstarke Werkzeuge zum Verwalten von Zahlungen, zum Schaffen neuer Einnahmequellen und zum Aufbau nachhaltiger Geschäftsmodelle. Unsere Commerce-Lösungen helfen, Dienste zu monetarisieren und die Profitabilität zu maximieren.",
        //     billing: {
        //       title: "JUHUU Billing",
        //       tagline: "Komplette Zahlungsinfrastruktur",
        //       description:
        //         "Umfassendes Finanzzentrum für Zahlungsabwicklung, automatische Rechnungserstellung, Auszahlungen an Betreiber und Tarifeinrichtung. Basierend auf Stripes Infrastruktur mit Echtzeit-Dashboard.",
        //       stats: {
        //         success: "Zahlungserfolgsrate",
        //         speed: "Schnellere Abwicklung",
        //         revenue: "Umsatzsteigerung",
        //       },
        //       cta: "Mehr zu Billing",
        //       altIcon: "JUHUU Billing",
        //       altImage: "JUHUU Billing Dashboard",
        //     },
        //     marketplace: {
        //       title: "JUHUU Marketplace",
        //       description:
        //         "Vertriebskanal, in dem OEMs zertifizierte und plattformintegrierte Geräte und Services listen, die Betreiber einfach übernehmen können.",
        //       cta: "Marketplace entdecken",
        //       altIcon: "JUHUU Marketplace",
        //     },
        //     revenueShare: {
        //       title: "JUHUU Revenue Share",
        //       comingSoon: "Demnächst",
        //       description:
        //         "Geplantes Affiliate-Programm, das Betreibern 15 % der Plattformgebühren für vermittelte Nutzer auszahlt, um Akquisitionskosten zu senken und Wachstum zu fördern.",
        //       altIcon: "JUHUU Revenue Share",
        //     },
        //     plusSubscriptions: {
        //       title: "Plus-Abos",
        //       comingSoon: "Demnächst",
        //       description:
        //         "Erstellen Sie Premium-Abostufen mit flexiblen Zahlungszyklen, Testphasen und besonderen Vorteilen für Abonnenten.",
        //       altIcon: "Plus Subscription",
        //     },
        //     testimonial: {
        //       quote:
        //         "\"Das Billing-System von JUHUU hat unsere Finanzprozesse revolutioniert. Die Zahlungsabwicklung dauert 60 % weniger Zeit und die Einnahmeneffizienz stieg um 35 % seit der Einführung.\"",
        //       name: "Thomas Weber",
        //       position: "CFO bei Urban Mobility Solutions",
        //       altPortrait: "Kundenporträt",
        //     },
        //     ctaTitle: "Bereit für ein neues Erlösmodell?",
        //     ctaButton: "Vertrieb kontaktieren",
        //   },
        //   operations: {
        //     tag: "Betrieb & Monitoring",
        //     title: "Betrieb steuern und optimieren",
        //     description:
        //       "Diese Kategorie bietet fortschrittliche Werkzeuge zur Überwachung, Verwaltung und Optimierung des Betriebs in Echtzeit. Sie liefert Betreibern und OEMs umfassende Einblicke in Assets, prädiktive Wartung und Leistungsanalysen, um Ausfallzeiten zu minimieren und Effizienz zu steigern.",
        //     dashboard: {
        //       title: "JUHUU Dashboard",
        //       description:
        //         "Das zentrale Kontrollzentrum für Betreiber und OEMs mit Echtzeit-Überwachung von Umsätzen, Gerätestatus, Auslastung und Supporteinsätzen. Liefert umfassende Einblicke mit anpassbaren Ansichten und Berichten.",
        //       cta: "Dashboard-Funktionen",
        //       altIcon: "Dashboard",
        //     },
        //     anomalyDetection: {
        //       title: "JUHUU AI Anomaly Detection",
        //       comingSoon: "Demnächst",
        //       description:
        //         "Nächste Generation eines Wartungsmoduls, das mittels ML und LLM Ausfälle vorhersagt, ungeplante Ausfallzeiten um bis zu 30 % reduziert und Wartungskosten um 25 % senkt – mit Alerts im Dashboard.",
        //       altIcon: "JUHUU AI Anomaly Detection",
        //     },
        //     demoTitle: "Dashboard-Demo",
        //   },
        //   customerSupport: {
        //     tag: "Kundensupport",
        //     title: "Support, der nie schläft",
        //     description:
        //       "Diese Kategorie bietet durchgehende, intelligente Supportlösungen, die Nutzer- und Betreibererlebnisse verbessern. KI und menschliche Expertise sorgen für sofortige Hilfe und eskalieren komplexe Anliegen, was hohe Zufriedenheit sichert und Supportkosten senkt.",
        //     buddy: {
        //       title: "JUHUU Buddy",
        //       description:
        //         "KI-gestützter Chatbot, trainiert auf JUHUU Docs und in allen Plattformen eingebettet. Beantwortet Fragen und erledigt Aufgaben wie Standortanlage oder Tarifänderungen rund um die Uhr.",
        //       bullets: [
        //         "Geschult auf Ihrer Dokumentation",
        //         "Erledigt operative Aufgaben automatisch",
        //         "Auf allen Plattformen verfügbar",
        //       ],
        //       cta: "JUHUU Buddy kennenlernen",
        //       overlay: "KI-basiert",
        //       altIcon: "JUHUU Buddy",
        //       altImage: "JUHUU Buddy",
        //     },
        //     customerSupport: {
        //       title: "JUHUU Customer Support",
        //       description:
        //         "Eine kommende multimodale Support-Suite mit eigenen Rufnummern, UI-bewusstem Kontext, automatischen Eskalationen und betreiberspezifischen Antworten aus den Docs. Bietet kanalübergreifend nahtlose Unterstützung.",
        //       bullets: [
        //         "Multikanal-Support (Chat, Telefon, E-Mail)",
        //         "Kontextbezogene Hilfe",
        //         "Intelligente Eskalation an menschliche Agenten",
        //       ],
        //       cta: "Support-Lösungen",
        //       overlay: "Demnächst",
        //       altIcon: "JUHUU Customer Support",
        //       altImage: "JUHUU Customer Support",
        //     },
        //   },
        // },
        productCategories: {
          coreInfrastructure: {
            tag: "Kerninfrastruktur & Entwicklerwerkzeuge",
            title: "Grundlage für Innovation schaffen",
            description:
              "Diese Kategorie bildet das Rückgrat des JUHUU-Ökosystems und stellt die notwendige Infrastruktur und Entwicklerwerkzeuge bereit, um schnelle Entwicklung, sichere Integration und skalierbare Abläufe für Shared Mobility und smarte Infrastruktur zu ermöglichen. Betreiber und OEMs erhalten so eine solide Basis, um effizient Innovationen umzusetzen.",
            identity: {
              title: "JUHUU Identity",
              description:
                "Zentraler Authentifizierungsdienst mit E-Mail/Passwort, Google-/Apple-Login und optionaler Ausweisprüfung.",
              cta: "Identity-Lösungen",
              alt: "JUHUU Identity",
            },
            docs: {
              title: "JUHUU Docs",
              description:
                "Umfassende Wissensdatenbank, in der OEMs und Betreiber Handbücher, technische Daten und Richtlinien hinterlegen.",
              cta: "Dokumentations-Hub",
              alt: "JUHUU Docs",
            },
            specialDevelopment: {
              title: "JUHUU Sonderentwicklung",
              description:
                "Maßgeschneiderter Integrationsservice für komplexe Anwendungsfälle mit individuell eingebetteten Systemen.",
              cta: "Individuelle Lösungen",
              alt: "JUHUU Sonderentwicklung",
            },
            digitalTwins: {
              title: "JUHUU Digital Twins",
              description:
                "Ein zentraler Hub, der virtuelle Zwillinge integrierter Geräte erstellt und Betreibern die Überwachung von Zustand und Status ermöglicht.",
              cta: "Digital-Twin-Plattform",
              alt: "JUHUU Digital Twins",
            },
            developerToolsLabel: "Developer Tools",
            bigImageAlt: "Kerninfrastruktur & Entwicklerwerkzeuge",
          },
          userAccess: {
            tag: "Zugangs- & Buchungsoberflächen",
            title: "Nahtloser Zugang jederzeit",
            description:
              "Diese Kategorie liefert benutzerfreundliche Oberflächen, die Buchung und Zugang zu Mobilitäts- und Infrastrukturdiensten über mehrere Plattformen hinweg vereinfachen.",
            app: {
              title: "JUHUU App",
              description:
                "Native iOS/Android-App, mit der Nutzer Dienste wie Bikes, Scooter und Schließfächer über eine einzige Oberfläche finden, buchen und nutzen können – inklusive White-Label-Optionen für Betreiber.",
              cta: "App-Funktionen",
              label: "Mobile App",
              altIcon: "JUHUU App",
              altImage: "JUHUU Mobile App",
              appStoreAlt: "Im App Store laden",
              googlePlayAlt: "Bei Google Play holen",
            },
            webApp: {
              title: "JUHUU Web App",
              description:
                "Browserbasierte Alternative zur JUHUU App mit vollständiger Buchungs- und Öffnungsfunktion für Gelegenheitsnutzer und reduziertem Funktionsumfang zur Förderung der nativen App.",
              cta: "Web-App-Plattform",
              altIcon: "JUHUU Web App",
            },
            map: {
              title: "JUHUU Map",
              description:
                "Interaktive Karte mit allen Standorten, anpassbaren Filtern und Betreiberbranding sowie Iframe-Einbindung für externe Plattformen gegen Aufpreis.",
              cta: "Interaktive Karte",
              altIcon: "JUHUU Map",
            },
          },
          commerce: {
            tag: "Commerce & Monetarisierung",
            title: "Transaktionen in Wachstum verwandeln",
            description:
              "Leistungsstarke Werkzeuge zum Verwalten von Zahlungen, zum Schaffen neuer Einnahmequellen und zum Aufbau nachhaltiger Geschäftsmodelle. Unsere Commerce-Lösungen helfen, Dienste zu monetarisieren und die Profitabilität zu maximieren.",
            billing: {
              title: "JUHUU Billing",
              tagline: "Komplette Zahlungsinfrastruktur",
              description:
                "Umfassendes Finanzzentrum für Zahlungsabwicklung, automatische Rechnungserstellung, Auszahlungen an Betreiber und Tarifeinrichtung. Basierend auf Stripes Infrastruktur mit Echtzeit-Dashboard.",
              stats: {
                success: "Zahlungserfolgsrate",
                speed: "Schnellere Abwicklung",
                revenue: "Umsatzsteigerung",
              },
              cta: "Mehr zu Billing",
              altIcon: "JUHUU Billing",
              altImage: "JUHUU Billing Dashboard",
            },
            marketplace: {
              title: "JUHUU Marketplace",
              description:
                "Vertriebskanal, in dem OEMs zertifizierte und plattformintegrierte Geräte und Services listen, die Betreiber einfach übernehmen können.",
              cta: "Marketplace entdecken",
              altIcon: "JUHUU Marketplace",
            },
            revenueShare: {
              title: "JUHUU Revenue Share",
              comingSoon: "Demnächst",
              description:
                "Geplantes Affiliate-Programm, das Betreibern 15 % der Plattformgebühren für vermittelte Nutzer auszahlt, um Akquisitionskosten zu senken und Wachstum zu fördern.",
              altIcon: "JUHUU Revenue Share",
            },
            plusSubscriptions: {
              title: "Plus-Abos",
              comingSoon: "Demnächst",
              description:
                "Erstellen Sie Premium-Abostufen mit flexiblen Zahlungszyklen, Testphasen und besonderen Vorteilen für Abonnenten.",
              altIcon: "Plus Subscription",
            },
            testimonial: {
              quote:
                '"Das Billing-System von JUHUU hat unsere Finanzprozesse revolutioniert. Die Zahlungsabwicklung dauert 60 % weniger Zeit und die Einnahmeneffizienz stieg um 35 % seit der Einführung."',
              name: "Thomas Weber",
              position: "CFO bei Urban Mobility Solutions",
              altPortrait: "Kundenporträt",
            },
            ctaTitle: "Bereit für ein neues Erlösmodell?",
            ctaButton: "Vertrieb kontaktieren",
          },
          operations: {
            tag: "Betrieb & Monitoring",
            title: "Betrieb steuern und optimieren",
            description:
              "Diese Kategorie bietet fortschrittliche Werkzeuge zur Überwachung, Verwaltung und Optimierung des Betriebs in Echtzeit. Sie liefert Betreibern und OEMs umfassende Einblicke in Assets, prädiktive Wartung und Leistungsanalysen, um Ausfallzeiten zu minimieren und Effizienz zu steigern.",
            dashboard: {
              title: "JUHUU Dashboard",
              description:
                "Das zentrale Kontrollzentrum für Betreiber und OEMs mit Echtzeit-Überwachung von Umsätzen, Gerätestatus, Auslastung und Supporteinsätzen. Liefert umfassende Einblicke mit anpassbaren Ansichten und Berichten.",
              cta: "Dashboard-Funktionen",
              altIcon: "Dashboard",
            },
            anomalyDetection: {
              title: "JUHUU AI Anomaly Detection",
              comingSoon: "Demnächst",
              description:
                "Nächste Generation eines Wartungsmoduls, das mittels ML und LLM Ausfälle vorhersagt, ungeplante Ausfallzeiten um bis zu 30 % reduziert und Wartungskosten um 25 % senkt – mit Alerts im Dashboard.",
              altIcon: "JUHUU AI Anomaly Detection",
            },
            demoTitle: "Dashboard-Demo",
          },
          customerSupport: {
            tag: "Kundensupport",
            title: "Support, der nie schläft",
            description:
              "Diese Kategorie bietet durchgehende, intelligente Supportlösungen, die Nutzer- und Betreibererlebnisse verbessern. KI und menschliche Expertise sorgen für sofortige Hilfe und eskalieren komplexe Anliegen, was hohe Zufriedenheit sichert und Supportkosten senkt.",
            buddy: {
              title: "JUHUU Buddy",
              description:
                "KI-gestützter Chatbot, trainiert auf JUHUU Docs und in allen Plattformen eingebettet. Beantwortet Fragen und erledigt Aufgaben wie Standortanlage oder Tarifänderungen rund um die Uhr.",
              bullets: [
                "Geschult auf Ihrer Dokumentation",
                "Erledigt operative Aufgaben automatisch",
                "Auf allen Plattformen verfügbar",
              ],
              cta: "JUHUU Buddy kennenlernen",
              overlay: "KI-basiert",
              altIcon: "JUHUU Buddy",
              altImage: "JUHUU Buddy",
            },
            customerSupport: {
              title: "JUHUU Customer Support",
              description:
                "Eine kommende multimodale Support-Suite mit eigenen Rufnummern, UI-bewusstem Kontext, automatischen Eskalationen und betreiberspezifischen Antworten aus den Docs. Bietet kanalübergreifend nahtlose Unterstützung.",
              bullets: [
                "Multikanal-Support (Chat, Telefon, E-Mail)",
                "Kontextbezogene Hilfe",
                "Intelligente Eskalation an menschliche Agenten",
              ],
              cta: "Support-Lösungen",
              overlay: "Demnächst",
              altIcon: "JUHUU Customer Support",
              altImage: "JUHUU Customer Support",
            },
          },
        },
      },
    },
    app: {
      heroBadge: "Die JUHUU App · Für Betreiber:innen",
      heroTitle: "Eine App für deine Kund:innen.",
      heroHighlight: "Unter deiner Marke.",
      heroDescription:
        "Shared Mobility, Fahrradparken und Bike Rental in einer App. Nativ für iOS & Android, als WebApp und als komplette Whitelabel-App. Wir binden nahezu jedes buchbare Angebot ein und liefern die passende Hardware gleich mit.",
      ctaBookDemo: "Demo buchen",
      ctaSeeOptions: "Varianten ansehen",
      platformIosAndroid: "iOS & Android",
      platformWebApp: "WebApp",
      platformWhitelabel: "Whitelabel",
      platform14Languages: "14+ Sprachen",
      heroPhoneAlt: "JUHUU App — Karte mit Angeboten in deiner Nähe",
      page: {
        deployKicker: "Drei Wege in die App",
        deployTitle: "So bringst du dein Angebot zu deinen Kund:innen.",
        deployCells: [
          {
            tag: "In der JUHUU App",
            title: "JUHUU-App",
            description:
              "Dein Bereich erscheint in der JUHUU App, mit deinen Farben, deinem Wording, Logo und Map-Marker. Sofort sichtbar für bestehende Nutzer:innen.",
          },
          {
            tag: "Eigene App",
            title: "Whitelabel App",
            description:
              "Eine komplett eigene App in deinem Look. Eigenes App-Icon, Ladescreen, Karte, Buttons und das gesamte Erscheinungsbild unter deiner Marke.",
          },
          {
            tag: "Ohne Installation",
            title: "WebApp",
            description:
              "Dieselbe Funktionalität direkt im Browser, ideal für QR-Einstieg vor Ort, ganz ohne Download aus dem Store.",
          },
        ],
        partialKicker: "Teil-Whitelabel · in der JUHUU App",
        partialTitleLine1: "Deine Marke,",
        partialTitleLine2: "in unserer App.",
        partialDescription:
          "Dein Angebot lebt in der JUHUU App und wird auf deine Marke angepasst. Nutzer:innen, die JUHUU schon haben, finden dich sofort, ohne eine neue App installieren zu müssen.",
        partialBullets: [
          "Interface -und Knopffarben",
          "Eigenes Wording & Logo",
          "Individuelle Map-Marker",
          "Custom-Funktionen im Hintergrund",
        ],
        standaloneKicker: "Whitelabel App · komplett eigenständig",
        standaloneTitleLine1: "Deine eigene App,",
        standaloneTitleLine2: "von A bis Z.",
        standaloneDescription:
          "Eine vollständig eigenständige App im Store, unter deinem Namen, in deinem Design. Wir passen das gesamte Erscheinungsbild an deine Marke an.",
        standaloneBullets: [
          "Eigenes App-Icon",
          "Ladescreen beim Öffnen der App",
          "Karte, Buttons & gesamtes Aussehen",
          "Eigener Auftritt im App Store & Google Play",
        ],
        standaloneCtaReferences: "Referenzen ansehen",
        featuresKicker: "In jeder Variante dabei",
        featuresTitle: "Alles, was eine Buchung braucht.",
        featuresList: [
          {
            title: "Unterschiedlichste Tarife",
            description:
              "Pay-as-you-go, Tages-, Monats- und Jahrestarife, Rabatte und Gutscheinkarten frei kombinierbar.",
          },
          {
            title: "Alle gängigen Zahlungsmittel",
            description:
              "Von Bankomat -und Kreditkarte über Apple Pay & Google Pay bis PayPal.",
          },
          {
            title: "Identitätsnachweis",
            description:
              "Optional fordern wir Nutzer:innen auf, ihre Identität mittels Reisepass, Führerschein oder Personalausweis zu bestätigen.",
          },
        ],
        paymentsKicker: "Zahlungsmittel über Stripe",
        hardwareKicker: "Hardware",
        hardwareTitleLine1: "Wir bieten alles:",
        hardwareTitleLine2: "Vom autarken Schloss bis zum Relay.",
        hardwareLead:
          "Wir bieten alles, um deinen Use Case abzubilden: von fix-fertigen Schließsystemen, die völlig autark laufen, bis hin zu Systemen, die wir über unsere Relay-Boards ansteuern. Und wir liefern die Hardware gleich mit, vom Schloss bis zur IoT-Konnektivität.",
        hardwareCards: [
          {
            title: "Fix-fertige Schließsysteme",
            description:
              "Komplette Schließsysteme, die autark laufen — Türen, Boxen, Schränke und Schiebetüren, auch als Nachrüstung. Die Schlösser und die IoT-Konnektivität liefern wir gleich mit.",
          },
          {
            title: "Neue Hardware einbinden",
            description:
              "Du hast spezielle Geräte? Wir binden neue Hardware an die Plattform an. Über No-Code-Vorlagen, Konfiguratoren oder unsere API.",
          },
          {
            title: "JUHUU Relay-Board",
            description:
              "Volle Freiheit: Mit unserem Relay-Board entscheidest du selbst, was angesteuert wird: Schranken, Schlösser, Lichter, Motoren oder was auch immer dein Use Case braucht.",
          },
        ],
        useCasesKicker: "Use Cases",
        useCasesTitle: "Standard-Use-Cases. Oder dein eigener.",
        useCasesDescription:
          "Fahrradparken, Bike Rental und Shared Mobility liefern wir als Standard. Alles darüber hinaus baust du mit unserer Standard-Software & -Elektronik. Oder komplett frei über das Relay-Board.",
        useCaseBikeParking: "Fahrradparken",
        useCaseBikeRental: "Bike Rental",
        useCaseSharedMobility: "Shared Mobility",
        useCaseStandard: "Standard",
        useCaseOwnTitle: "Eigener Use Case",
        useCaseOwnSubtitle: "Software / Elektronik / Relay",
        logosTitle: "Im Einsatz für",
        finalCtaTitle: "Welche Variante passt zu dir?",
        finalCtaDescription:
          "In einer kostenlosen Demo finden wir heraus, ob Teil-Whitelabel, eigene App oder WebApp am besten zu deinem Angebot passt.",
      },
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      fastDeployment: "Schnelle Bereitstellung",
      modularDesign: "Modulares Design",
      aiEnhanced: "KI-unterstützt",
      bookingTitle: "Nahtloses Buchungserlebnis",
      bookingDescription:
        "Von der Entdeckung bis zur Nutzung in nur wenigen Fingertipps – sehen Sie, wie Ihre Kunden einfach auf Ihre Dienste zugreifen können",
      timeline: {
        scan: "Scannen",
        select: "Auswählen",
        pay: "Bezahlen",
        use: "Nutzen",
      },
      steps: [
        {
          title: "QR-Code scannen",
          desc: "Öffnen Sie einfach die App und scannen Sie den QR-Code, um verfügbare Dienste in Ihrer Nähe zu entdecken.",
        },
        {
          title: "Tarif wählen",
          desc: "Stöbern Sie in den verfügbaren Optionen und wählen Sie den Tarif, der am besten zu Ihren Bedürfnissen passt.",
        },
        {
          title: "Bezahlen",
          desc: "Schließen Sie Ihre Buchung mit einer sicheren Zahlung über Ihre bevorzugte Zahlungsmethode ab.",
        },
        {
          title: "Produkt nutzen",
          desc: "Tippen Sie zum Entsperren und nutzen Sie den Service sofort – keine Schlüssel oder Karten erforderlich.",
        },
      ],
      downloadText:
        "Laden Sie die JUHUU App herunter und legen Sie noch heute los",
      featuresTag: "Funktionen",
      featuresTitle: "Umfassende Plattform",
      featuresDescription:
        "Unsere JUHUU WebApp bietet einen kompletten Satz an Werkzeugen zur Verwaltung von Mobilitätsdiensten, Infrastruktur und Versorgungsleistungen",
      customInterfaceTag: "Anpassbare Oberfläche",
      customInterfaceTitle: "Ihre Marke, unsere Technologie",
      customInterfaceDescription:
        "JUHUU ermöglicht Anbietern, ihre eigene Corporate Identity nahtlos in die App zu integrieren. Behalten Sie Ihre Markenidentität bei und nutzen Sie gleichzeitig unsere leistungsstarke Plattform.",
      becomePartner: "Partner werden",
      customInterfaces: [
        {
          title: "Individuelles Branding",
          description:
            "Anbieter können ihr eigenes Logo, ihre Farben und ihr Design in die App integrieren.",
          features: [
            "Eigenes Logo einbinden",
            "Ihre Markenfarben anwenden",
            "Produktnamen anpassen",
            "Konsistentes Markenerlebnis",
          ],
        },
        {
          title: "Individuelle Tarife",
          description:
            "Flexible Tarifgestaltung und Produktkategorisierung nach Ihren Bedürfnissen.",
          features: [
            "Eigene Tarifstrukturen",
            "Sonderrabatte und Angebote",
            "Zeit- oder nutzungsbasierte Abrechnung",
            "Flexible Preisoptionen",
          ],
        },
        {
          title: "Nahtlose Integration",
          description:
            "Vollständige Einbindung in bestehende Markenidentitäten wie ÖBB Bike.",
          features: [
            "Konsistenz mit anderen Markenkanälen",
            "Vertraute Oberfläche für Kunden",
            "Anpassbare Feature-Bezeichnungen",
            "Eigene Nutzungsbedingungen",
          ],
        },
      ],
      liveDemoTag: "Live-Demo",
      liveDemoTitle: "Erleben Sie JUHUU in Aktion",
      liveDemoDescription:
        "Entdecken Sie verfügbare Standorte, Betreiber und Services in Echtzeit. Sehen Sie, wie einfach es ist, Mobilitätsdienste in unserem wachsenden Netzwerk zu finden und zu buchen.",
      mapHeading: "Interaktive Kartenerfahrung",
      mapDescription:
        "Durchsuchen Sie unsere interaktive Karte, um alle verfügbaren Dienste in Ihrer Nähe zu sehen. Erkunden Sie verschiedene Betreiber, Standorte und Mobilitätsoptionen an einem Ort.",
      statProviders: "Serviceanbieter",
      statBookingTime: "Durchschnittliche Buchungszeit",
      statAvailability: "Serviceverfügbarkeit",
      partners: "Bereits Partner von uns",
      joinOperator: "Werden Sie Betreiber",
      appStoreAlt: "Im App Store herunterladen",
      googlePlayAlt: "Bei Google Play laden",
      viewCustomInterface: "Benutzeroberfläche ansehen",
      featuresList: [
        {
          title: "Mobilität",
          description:
            "Umfassende Mobilitätslösungen für urbane Transportbedürfnisse.",
          benefits: [
            "Nahtlose Integration in den öffentlichen Verkehr",
            "Echtzeit-Tracking und Benachrichtigungen",
            "Flexible Zahlungsoptionen",
            "Multimodale Routenplanung",
          ],
        },
        {
          title: "Infrastruktur",
          description:
            "Intelligentes Infrastrukturmanagement für Städte und Unternehmen.",
          benefits: [
            "IoT-gestützte Überwachungssysteme",
            "Prädiktive Wartung",
            "Ressourcenoptimierung",
            "Umweltwirkung verfolgen",
          ],
        },
        {
          title: "Versorgung",
          description:
            "Effizientes Versorgungsmanagement für moderne Anforderungen.",
          benefits: [
            "Integration von Smart Metering",
            "Nutzungsanalysen und Einblicke",
            "Automatisierte Abrechnungssysteme",
            "Verbrauchsoptimierung",
          ],
        },
        {
          title: "Zahlungen",
          description:
            "Sichere und flexible Zahlungsabwicklung für alle Services.",
          benefits: [
            "Mehrere Zahlungsmethoden",
            "Abonnementverwaltung",
            "Automatisierte Rechnungsstellung",
            "Umsatzbeteiligungsfunktionen",
          ],
        },
        {
          title: "Analysen",
          description:
            "Leistungsstarke Analysetools zur Unterstützung von Geschäftsentscheidungen.",
          benefits: [
            "Dashboards in Echtzeit",
            "Individuelle Berichte",
            "Predictive Analytics",
            "Einblicke in das Nutzerverhalten",
          ],
        },
        {
          title: "Integration",
          description:
            "Nahtlose Integration in bestehende Systeme und Drittanbieterdienste.",
          benefits: [
            "Offene API-Architektur",
            "Individuelle Konnektoren",
            "Kompatibilität mit Altsystemen",
            "Plug-and-play-Module",
          ],
        },
        {
          title: "Sicherheit",
          description:
            "Sicherheit auf Enterprise-Niveau für alle Plattformkomponenten.",
          benefits: [
            "Ende-zu-Ende-Verschlüsselung",
            "Mehrfaktor-Authentifizierung",
            "Regelmäßige Sicherheitsprüfungen",
            "Einhaltung globaler Standards",
          ],
        },
      ],
    },
    map: {
      heroTitle: "Interaktive Karte für Mobilitätsdienste",
      heroDescription:
        "JUHUU Map bietet eine interaktive Kartenlösung, die in Echtzeit Standorte, Verfügbarkeit und Routen Ihrer Mobilitätsdienste anzeigt. Binden Sie sie mit unserer flexiblen Iframe-Integration überall ein.",
      features: {
        realtimeTitle: "Echtzeit-Tracking",
        realtimeDesc: "Live-Fahrzeugstandorte und Verfügbarkeitsstatus",
        integrationTitle: "Einfache Integration",
        integrationDesc: "Einfaches Einbetten per Iframe auf jeder Website",
        globalTitle: "Globale Abdeckung",
        globalDesc: "Funktioniert weltweit mit lokalen Kartendaten",
        mobileTitle: "Für Mobilgeräte optimiert",
        mobileDesc: "Responsives Design für alle Endgeräte",
      },
      liveDemoBadge: "Live-Demo",
      liveMapTitle: "Interaktive Live-Karte",
      liveMapDescription:
        "Erleben Sie unsere interaktive Karte in Aktion. Es ist die gleiche Karte, die Mobilitätsdienste in ganz Europa antreibt.",
      builtForOperatorsTitle: "Für Betreiber entwickelt",
      builtForOperatorsDescription:
        "Unternehmen, die unsere JUHUU-Plattform nutzen, können diese interaktive Karte nahtlos in ihre eigene Website einbetten. Es werden nur die Standorte und Fahrzeuge des jeweiligen Betreibers angezeigt – perfekt für ein maßgeschneidertes Kundenerlebnis.",
      bulletPoints: {
        locationsTitle: "Nur Ihre Standorte",
        locationsDesc:
          "Die Karte zeigt ausschließlich Ihre Fahrzeuge und Stationen an",
        bookingTitle: "Direkte Buchung möglich",
        bookingDesc:
          "Kunden können direkt über die eingebettete Karte buchen – genau wie über die JUHUU WebApp",
        brandingTitle: "Ihr Branding",
        brandingDesc: "Anpassbar an Ihr Corporate Design und Ihre Marke",
        operatorTitle: "Für Betreiber optimiert",
        operatorDesc:
          "Speziell für Dienstanbieter entwickelt, die ihre Services professionell präsentieren möchten",
      },
      integrationTitle: "Einfache Einbindung",
      integrationDescription:
        "Kopieren Sie diesen Code und fügen Sie ihn auf Ihrer Website ein, um die JUHUU Web App anzuzeigen.",
      iframeTitle: "JUHUU Interaktive Karte",
    },
    marketplace: {
      heroTitle: "Willkommen im",
      heroHighlight: "JUHUU Marktplatz",
      heroDescription:
        "Entdecken Sie spezialisierte Lösungen unserer vertrauenswürdigen Partner, um Ihre Mobilitätsplattform zu erweitern. Unser Marktplatz bietet eine Vielzahl an Produkten, die nahtlos mit JUHUU zusammenarbeiten.",
      browseTitle: "Produkte durchsuchen",
      browseDescription:
        "Filtern und durchsuchen Sie unsere kuratierte Sammlung von Mobilitätslösungen, um die perfekte Option für Ihre Anforderungen zu finden.",
      showing: "Zeige",
      of: "von",
      products: "Produkten",
      loadMore: "Mehr laden",
      loading: "Lädt…",
      noProductsTitle: "Keine Produkte gefunden",
      noProductsDescription: "Passen Sie Ihre Suche oder Filterkriterien an",
      clearFilters: "Alle Filter löschen",
      close: "Schließen",
      readMore: "Mehr erfahren",
      productImageAlt: "Produktbild",
      ctaTitle: "Bereit, Ihr Unternehmen zu transformieren?",
      ctaSubTitle: "missing translation",
      ctaLaunch: "Starten Sie Ihre Lösung in Wochen, nicht Monaten",
      ctaScale: "Skalieren Sie nahtlos mit Ihrem Wachstum",
      ctaPay:
        "Zahlen Sie nur für das, was Sie nutzen – dank unseres modularen Ansatzes",
      ctaStart: "Heute starten",
      ctaFullName: "Vollständiger Name",
      ctaWorkEmail: "Geschäftliche E-Mail-Adresse",
      ctaCompany: "Unternehmen",
      ctaNamePlaceholder: "Name eingeben",
      ctaEmailPlaceholder: "sie@unternehmen.com",
      ctaCompanyPlaceholder: "Name Ihres Unternehmens",
      ctaSubmit: "Vertrieb kontaktieren",
      ctaConsent: "Mit dem Absenden dieses Formulars stimmen Sie unseren",
      ctaTerms: "Nutzungsbedingungen",
      ctaPrivacy: "Datenschutzrichtlinie",
      ctaAnd: "und",
    },
    billing: {
      heroTitle: "Zahlungen und",
      heroHighlight: "Umsatzmanagement vereint",
      heroDescription:
        "JUHUU Billing ist die vollständige Finanzinfrastruktur, die jede Transaktion auf der JUHUU-Plattform abwickelt. Aufbauend auf Stripe Connect automatisiert sie Zahlungsabwicklung, Rechnungsstellung, Gebührenerfassung und monatliche Auszahlungen und bietet Betreibern eine verlässliche Quelle der Wahrheit für ihre Finanzen.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      statusLoading: "Bitte warten...",
      statusSent: "Erfolgreich gesendet!",
      statusError: "Fehler, erneut versuchen.",
      heroBulletPoints: [
        "Sofortige Zahlungsabwicklung",
        "Automatisierte Rechnungen",
        "Monatliche Auszahlungen",
      ],
      section: {
        logoAlt: "JUHUU Billing",
        title: "Zentrale Zahlungs- und Umsatzschicht",
        slogan: "Basierend auf Stripe Connect für reibungslose Finanzprozesse",
        description:
          "JUHUU Billing ist die einheitliche Zahlungs- und Umsatzmanagement-Schicht der JUHUU-Plattform. Sie automatisiert Zahlungsabwicklung, Teilautorisierungen, Rechnungserstellung, Gebührenerfassung und monatliche Auszahlungen und liefert Betreibern eine zuverlässige Finanzübersicht.",
        primaryCta: "Jetzt starten",
        secondaryCta: "Dokumentation",
        features: [
          {
            title: "Sofortige Zahlungsabwicklung",
            description:
              "Belastet Kunden automatisch, sobald eine Buchung bestätigt wird.",
          },
          {
            title: "Teilautorisierung",
            description:
              "Hält bei Pay-as-you-go zunächst einen Betrag und verrechnet nach Nutzungsende den exakten Betrag.",
          },
          {
            title: "Automatisierte Rechnungen",
            description:
              "Erstellt rechtssichere Rechnungen im Namen des Betreibers bei Buchungsabschluss oder Nutzungsende.",
          },
          {
            title: "Gebührenmanagement",
            description:
              "Zieht JUHUU-Provisionen und monatliche Betreibergebühren in Echtzeit transparent ab.",
          },
          {
            title: "Monatliche Auszahlungen & Abrechnungen",
            description:
              "Fasst alle Zahlungen, Rückerstattungen und Gebühren in einer Stripe-Auszahlung zusammen.",
          },
          {
            title: "Buchungsbereiche",
            description:
              "Gruppiert Umsätze nach Bezirk, Stadt oder Gebäude für detaillierte Berichte ohne Einfluss auf Rechnungen.",
          },
          {
            title: "Self-Service-Rückerstattungen",
            description:
              "Ermöglicht vollständige oder teilweise Rückerstattungen direkt im Betreiberinterface mit automatischer Stripe-Synchronisierung.",
          },
          {
            title: "Transaktionen in Echtzeit",
            description:
              "Zeigt jede Zahlung, Rückerstattung, Gebühr und Rechnung im JUHUU Dashboard an.",
          },
        ],
        stats: {
          supportedCurrencies: "Unterstützte Währungen",
          paymentMethods: "Zahlungsmethoden",
          supportCountries: "Länder unterstützt",
        },
      },
      featuresDetail: {
        title: "Vollständige Zahlungsinfrastruktur",
        description:
          "Entdecken Sie die umfassenden Funktionen, die JUHUU Billing zur robustesten Zahlungs­lösung für Mobilitätsbetreiber machen",
        navTitle: "Wesentliche Funktionen",
        howItWorks: "Funktionsweise",
        keyBenefits: "Zentrale Vorteile",
        features: [
          {
            title: "Sofortige Zahlungsabwicklung",
            description: "Belastet Kunden automatisch bei Buchungsbestätigung",
            details: [
              "Automatische Abbuchung bei Buchung",
              "Integration in alle JUHUU Buchungen",
              "Echtzeit-Status der Zahlungen",
              "Unterstützt mehrere Zahlungsmethoden",
            ],
            benefits: [
              "Weniger Zahlungsfehler",
              "Umsatz sofort verbuchen",
              "Nahtloses Kundenerlebnis",
            ],
          },
          {
            title: "Teilautorisierung",
            description:
              "Hält zunächst einen geschätzten Betrag und verrechnet am Ende den tatsächlichen Betrag",
            details: [
              "Vorautorisierung des geschätzten Betrags",
              "Automatische Endabrechnung",
              "Minuten- oder sekundengenaue Produkte",
              "Intelligente Berechnung des Betrags",
            ],
            benefits: [
              "Weniger Rückbuchungen",
              "Faire Preise für Kunden",
              "Optimierter Cashflow",
            ],
          },
          {
            title: "Automatisierte Rechnungen",
            description:
              "Erstellt rechtssichere Rechnungen im Namen des Betreibers",
            details: [
              "Rechtssichere Rechnungserstellung",
              "Mehrsprachige Unterstützung",
              "Fortlaufende Nummerierung",
              "10 Jahre Dokumentenaufbewahrung",
            ],
            benefits: [
              "Steuerkonforme Abwicklung",
              "Weniger Verwaltungsaufwand",
              "Professionelle Kommunikation",
            ],
          },
          {
            title: "Monatliche Auszahlungen & Abrechnungen",
            description:
              "Bündelt alle Zahlungen, Rückerstattungen und Gebühren in einer Stripe-Auszahlung",
            details: [
              "Automatisierte monatliche Auszahlung",
              "Umfassende CSV- und PDF-Abrechnungen",
              "Detaillierte Aufschlüsselung",
              "Benachrichtigungen per E-Mail und Dashboard",
            ],
            benefits: [
              "Vereinfachte Abstimmung",
              "Volle finanzielle Transparenz",
              "Effiziente Buchhaltung",
            ],
          },
          {
            title: "Buchungsbereiche",
            description:
              "Gruppiert Umsätze nach Bezirk, Stadt oder Gebäude für detaillierte Berichte",
            details: [
              "Virtuelle Kostenstellen",
              "Berichte auf Bezirks-, Stadt- oder Gebäudeebene",
              "Kein Einfluss auf Rechnungsnummern oder Steuern",
              "Nur lesbar in Rechnungen",
            ],
            benefits: [
              "Performance mehrerer Standorte",
              "Detaillierte Umsatzanalysen",
              "Compliance-sichere Berichte",
            ],
          },
          {
            title: "Self-Service-Rückerstattungen",
            description:
              "Voll- oder Teilrückerstattungen direkt im Betreiberinterface",
            details: [
              "Komplette und teilweise Rückerstattungen",
              "Automatische Stripe-Synchronisierung",
              "Gutschriftenerstellung",
              "Prüfprotokoll",
            ],
            benefits: [
              "Schnellerer Kundenservice",
              "Weniger Supportaufwand",
              "Volle Transparenz",
            ],
          },
          {
            title: "Transaktionen in Echtzeit",
            description:
              "Zeigt alle Zahlungen, Rückerstattungen, Gebühren und Rechnungen im JUHUU Dashboard",
            details: [
              "Live-Überwachung der Transaktionen",
              "Vollständige Zahlungshistorie",
              "Verknüpfte Rechnungsverfolgung",
              "Statusupdates in Echtzeit",
            ],
            benefits: [
              "Probleme sofort lösen",
              "Bessere Übersicht",
              "Proaktiver Support",
            ],
          },
        ],
      },
      paymentFlow: {
        title: "Zahlungsablauf visualisiert",
        description:
          "Sehen Sie, wie JUHUU Billing Zahlungen vom Buchen bis zur Dashboard-Anzeige in Echtzeit verarbeitet",
        play: "Start",
        pause: "Pause",
        reset: "Zurücksetzen",
        steps: [
          {
            title: "Buchungsereignis",
            description:
              "JUHUU Booking sendet einen Payment Intent an JUHUU Billing",
            details:
              "Bei Buchungsbestätigung wird automatisch ein Payment Intent mit allen notwendigen Transaktionsdaten erstellt.",
          },
          {
            title: "Kartenzahlung",
            description:
              "Stripe führt die Abbuchung durch, Gelder landen beim Betreiber",
            details:
              "Stripe verarbeitet die Zahlung sicher und überweist den Betrag abzüglich der JUHUU-Gebühr auf das Stripe-Konto des Betreibers.",
          },
          {
            title: "Teilautorisierung",
            description:
              "Bei Pay-as-you-go reserviert JUHUU einen geschätzten Betrag",
            details:
              "Für flexible Mietdauern wird ein Betrag reserviert und nach Nutzungsende in die genaue Abbuchung umgewandelt.",
          },
          {
            title: "Rechnungserstellung",
            description: "PDF-Rechnung wird in der Sprache des Kunden erstellt",
            details:
              "Eine rechtssichere Rechnung wird automatisch in der Sprache des Kunden generiert und im Betreiberkonto archiviert.",
          },
          {
            title: "Dashboard-Sichtbarkeit",
            description:
              "Vollständige Zahlung sofort im JUHUU Dashboard sichtbar",
            details:
              "Alle Zahlungsinformationen, die verknüpfte Rechnung und Rückerstattungen sind sofort im Dashboard ersichtlich.",
          },
        ],
        cards: [
          {
            title: "Sicherheit zuerst",
            description:
              "Basiert auf Stripes PCI DSS Level 1 Infrastruktur mit Ende-zu-Ende-Verschlüsselung und Betrugsschutz.",
          },
          {
            title: "Globale Skalierung",
            description:
              "Akzeptiert lokale Zahlungsmethoden und automatische Währungsumrechnung.",
          },
          {
            title: "Überwachung in Echtzeit",
            description:
              "Verfolgen Sie jede Transaktion in Echtzeit mit umfassenden Logs und sofortigen Benachrichtigungen bei Problemen.",
          },
        ],
      },
      availableNow: "Jetzt verfügbar",
    },
    docs: {
      heroTitle: "Intelligentes",
      heroHighlight: "Wissensmanagement",
      heroDescription:
        "JUHUU Docs verwandelt verstreutes Betreiberwissen in eine durchsuchbare, mehrsprachige Ressource. KI-gest\u00fctzte Zusammenfassungen, automatische \u00dcbersetzungen und die nahtlose Integration mit JUHUU Buddy erm\u00f6glichen schnelleren Support und besseren Self-Service \u00fcber die gesamte JUHUU Plattform.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Loslegen",
      wait: "Bitte warten...",
      sent: "Erfolgreich gesendet!",
      error: "Fehler, klicken Sie zum Wiederholen.",
      unlimitedArticles: "Unbegrenzte Artikel",
      languages: "14 Sprachen",
      aiSearch: "KI-gest\u00fctzte Suche",
      components: {
        section1: {
          heading: "JUHUU Docs",
          description:
            "Verstreutes Wissen in eine durchsuchbare, mehrsprachige Ressource verwandeln, die besseren Support und Self-Service \u00fcber deine gesamte Plattform erm\u00f6glicht.",
          articleManagementTitle: "Artikelverwaltung",
          articleManagementSubtitle: "Unbegrenzte Inhaltserstellung",
          articleManagementDescription:
            "Erstelle und lade unbegrenzt viele Artikel direkt im JUHUU Dashboard hoch. Halte Produkt-, Preis- und Standortinformationen mit sofortiger Ver\u00f6ffentlichung immer aktuell.",
          articleManagementItems: [
            "Unbegrenzte Artikel",
            "Sofortige Ver\u00f6ffentlichung",
            "Aktualisierungen in Echtzeit",
          ],
          multilingualTitle: "14 Sprachen",
          multilingualSubtitle: "KI-gest\u00fctzte \u00dcbersetzung",
          multilingualDescription:
            "Jeder Artikel kann in 14 UI-Sprachen angezeigt werden. Fehlende \u00dcbersetzungen werden bei der ersten Anfrage automatisch von der JUHUU KI erstellt.",
          multilingualLabels: {
            languages: "Sprachen",
            languagesDesc: "14+ unterst\u00fctzte Sprachen",
            aiTranslation: "KI-\u00dcbersetzung",
            aiTranslationDesc: "Kein manueller Aufwand",
          },
          aiSummariesTitle: "KI-Zusammenfassungen & Link-Vorschauen",
          aiSummariesDescription:
            "Jeder Artikel wird automatisch zusammengefasst. Beim \u00dcberfahren interner Links erscheint die Zusammenfassung als Vorschau f\u00fcr schnellere Navigation und sofortigen Kontext.",
          aiSummariesItems: [
            "Automatisch erstellt",
            "Link-Vorschauen",
            "Sofortiger Kontext",
          ],
          integratedSearchTitle: "Integrierte Suche",
          integratedSearchDescription:
            "Volltext- und semantische Suche \u00fcber alle Artikel, gefiltert auf die Sprache des Betrachters. Nutzer und Support finden so in Sekundenschnelle die richtige Antwort.",
          integratedSearchItems: [
            "Volltextsuche",
            "Semantische Suche",
            "Sprachfilter",
          ],
          supportBridgeTitle: "Kundensupport-Br\u00fccke",
          supportBridgeDescription:
            "Wenn JUHUU Customer Support aktiviert ist, werden alle Artikel von JUHUU Buddy verarbeitet, damit der Chatbot Nutzerfragen mit zitierten Passagen beantworten kann.",
          supportBridgeItems: [
            "Tickets vermeiden",
            "Schnellere L\u00f6sungen",
            "Konsistente Antworten",
          ],
          cta: "Beginne mit dem Aufbau deiner Wissensdatenbank",
        },
      },
    },
    identity: {
      heroTitle: "Single Sign-On &",
      heroHighlight: "Kontoverwaltung",
      heroDescription:
        "JUHUU Identity ist das Single-Sign-On- und Kontoverwaltungs-R\u00fcckgrat der JUHUU Plattform. Sobald sich ein Nutzer anmeldet, erkennen alle Frontends \u2014 JUHUU App, JUHUU Web App, JUHUU Dashboard, JUHUU Docs, JUHUU Marketplace und zuk\u00fcnftige Module \u2014 diese Session automatisch.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      wait: "Bitte warten...",
      sent: "Erfolgreich gesendet!",
      error: "Fehler, zum erneuten Senden klicken.",
      badges: {
        universal: "Universelles SSO",
        multiTenant: "Mandantenf\u00e4hige Identit\u00e4t",
        enterprise: "Enterprise-Sicherheit",
      },
      card: {
        title: "Eine Identit\u00e4t",
        description: "Zugriff auf alle JUHUU-Dienste",
        services: [
          "JUHUU App",
          "JUHUU Dashboard",
          "JUHUU Marketplace",
          "JUHUU Docs",
        ],
      },
      capabilities: {
        title: "Wichtigste Funktionen",
        description:
          "Umfassendes Identit\u00e4tsmanagement, das mit Ihrem Unternehmen w\u00e4chst",
        items: [
          {
            title: "Universelles SSO",
            description: "Ein Konto schaltet jedes JUHUU-Produkt frei",
            benefits: "Endnutzer, Betreiber, OEMs",
          },
          {
            title: "Mandantenf\u00e4hige Identit\u00e4t",
            description:
              "Erm\u00f6glicht Kommunen oder Unternehmen die Anbindung eigener OAuth/SAML-Provider",
            benefits: "Stadtpartner, Firmenflotten",
          },
          {
            title: "Flexible Authentifizierung",
            description:
              "E-Mail + Passwort, Google Sign-In, Apple ID; Magic-Link-Flow bald verf\u00fcgbar",
            benefits: "Reibungsloser Einstieg",
          },
          {
            title: "Selbstbedienungsprofil",
            description:
              "Nutzer aktualisieren Name, Adresse oder UID direkt in JUHUU App / Dashboard",
            benefits: "Weniger Support-Aufwand",
          },
          {
            title: "Management-Konten",
            description:
              "Geteilte Wallets laden Mitglieder ein, zahlen zentral und ordnen Buchungen flexibel zu",
            benefits: "Unternehmen, Vereine, \u00f6ffentliche Einrichtungen",
          },
        ],
      },
      authentication: {
        title: "Authentifizierung & SSO",
        sections: [
          {
            title: "Sichere JWT-Authentifizierung",
            description:
              "Jede API-Anfrage wird von einem sicheren JWT begleitet, sodass nachgelagerte Dienste (z.B. JUHUU Booking, JUHUU Billing) den Benutzerrechten ohne zus\u00e4tzliche Abfragen vertrauen.",
          },
          {
            title: "Sofortiger Session-Transfer",
            description:
              "Einmal in der JUHUU App anmelden \u2192 JUHUU Web App \u00f6ffnen und sofort authentifiziert sein. Keine mehrfachen Logins n\u00f6tig.",
          },
        ],
        flow: {
          title: "Authentifizierungsablauf",
          description: "So funktioniert SSO \u00fcber alle JUHUU-Dienste",
          steps: [
            {
              title: "Benutzeranmeldung",
              description: "Bei einem beliebigen JUHUU-Dienst anmelden",
            },
            {
              title: "JWT-Token ausgegeben",
              description: "Sicheres Token f\u00fcr alle Dienste",
            },
            {
              title: "Zugriff auf alle Dienste",
              description: "\u00dcberall nahtloses Erlebnis",
            },
          ],
        },
      },
      accounts: {
        title: "Kontotypen",
        description:
          "Flexible Kontostrukturen f\u00fcr Einzelpersonen und Organisationen",
        highlights: "Highlights:",
        types: [
          {
            type: "Pers\u00f6nliches Konto",
            holder: "Individuelle Endnutzer",
            highlights: [
              "Standardbuchungen",
              "Gespeicherte Zahlungsmittel",
              "Profil bearbeiten",
            ],
          },
          {
            type: "Management-Konto",
            holder: "Unternehmen, Vereine, Kommunen",
            highlights: [
              "Unternehmenszahlungsmittel hinterlegen",
              "Unbegrenzte Mitglieder einladen",
              "Ressourcen einmal buchen und bei Bedarf an Mitglieder verteilen",
              "Kosten zentral verfolgen",
            ],
          },
        ],
        featuresTitle: "Funktionen des Management-Kontos",
        features: [
          {
            title: "Firmenzahlung",
            description: "Zentrale Abrechnung und Zahlungsmittel",
          },
          {
            title: "Mitgliederverwaltung",
            description: "Beliebig viele Teammitglieder einladen und verwalten",
          },
          {
            title: "Nutzungsanalyse",
            description: "Kosten zentral \u00fcberwachen",
          },
          {
            title: "Ressourcensteuerung",
            description: "Einmal buchen, an Mitglieder verteilen",
          },
        ],
      },
      security: {
        title: "Sicherheitspraktiken",
        description: "Unternehmenssicherheit in jeder Ebene von JUHUU Identity",
        items: [
          {
            title: "Passwortsicherheit",
            description:
              "Passw\u00f6rter werden mit bcrypt 12 gehasht und niemals im Klartext gespeichert.",
          },
          {
            title: "Tokenverwaltung",
            description:
              "Alle Tokens verwenden kurzlebige Zugriffe (15 Min.) und rotierende Refresh Tokens.",
          },
          {
            title: "Angriffsschutz",
            description: "Integrierte Rate-Limit-Mechanismen.",
          },
          {
            title: "Datenresidenz",
            description:
              "Datenresidenz entspricht der EU-DSGVO und lokalen Datenschutzgesetzen.",
          },
        ],
        badgeTitle: "State-of-the-Art-Sicherheit",
        uptime: "Uptime SLA",
        tokenLifetime: "Token-Lebensdauer",
        hashRounds: "Hash-Runden",
        monitoring: "\u00dcberwachung",
      },
    },
    digitalTwins: {
      heroTitle: "Geräteverwaltungs-Hub der",
      heroHighlight: "JUHUU Plattform",
      heroDescription:
        "JUHUU Digital Twins ermöglicht es Betreibern, jedes physische Asset – von E-Scootern und Schließfächern bis hin zu kompletter Infrastruktur – als konfigurierbaren digitalen Zwilling abzubilden, der in Echtzeit steuerbar ist und mit eigener Logik angereichert werden kann.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      statusLoading: "Bitte warten...",
      statusSent: "Erfolgreich gesendet!",
      statusError: "Fehler, klicken Sie um es erneut zu versuchen.",
      bullets: {
        registry: "Geräteregister & -steuerung",
        automation: "Step-Chain-Automatisierung",
        edge: "Edge-Ausführung",
      },
      dashboardSample: {
        title: "Digital Twin Dashboard",
        subtitle: "Gerätesteuerung in Echtzeit",
        batteryLevel: "Batteriestand",
        doorStatus: "Türstatus",
        unlockDevice: "Gerät entsperren",
      },
      section: {
        title: "Geräteverwaltungs-Hub der JUHUU Plattform",
        slogan:
          "Lebendige, konfigurierbare digitale Zwillinge für jedes physische Asset",
        description:
          "JUHUU Digital Twins ermöglicht es Betreibern, jedes physische Asset – von E-Scootern und Schließfächern bis hin zu kompletter Infrastruktur – als konfigurierbaren digitalen Zwilling abzubilden, der in Echtzeit steuerbar ist und mit eigener Logik angereichert werden kann.",
        primaryCta: "Geräteverwaltung starten",
        secondaryCta: "Dokumentation ansehen",
        badge: "KERNPLATTFORM",
        logoAlt: "JUHUU Digital Twins",
        imageAlt: "JUHUU Digital Twins Dashboard zur Geräteverwaltung",
        features: {
          registryTitle: "Geräteregister & -steuerung",
          registryDesc:
            "Erstellt einen eindeutigen digitalen Datensatz für jede Hardware inklusive benutzerdefinierter Felder und Befehle. Zentralisiert die Flottenüberwachung und ermöglicht Fernaktionen mit einem Klick.",
          automationTitle: "Step-Chain-Automatisierung",
          automationDesc:
            "Drag-and-drop-'Step-Chains' lösen Aktionen bei Ereignissen aus. Führt Geschäftslogik automatisch auf dem Server, in der JUHUU App oder direkt auf JUHUU Hardware aus.",
          uiLayoutsTitle: "Gerätespezifische UI-Layouts",
          uiLayoutsDesc:
            "Visueller Editor erstellt Bedienfelder und Steuerelemente, die auf jedes Gerät zugeschnitten sind. Ermöglicht Anwendern eine intuitive Bedienung ohne native Programmierung.",
          parameterTitle: "Parameterverwaltung",
          parameterDesc:
            "Plattformweite Parameter speichern Live-Zustände – Türstatus, Reifendruck u.v.m. – und führen eine vollständige Historie. Ermöglicht Monitoring, Dashboards und Analysen.",
          edgeExecutionTitle: "Edge-Ausführung",
          edgeExecutionDesc:
            "Step-Chain-Logik kann auf registrierte JUHUU-Hardware heruntergeladen und lokal via MQTT, HTTP oder RS-485 ausgeführt werden – sogar offline.",
        },
        stats: {
          deviceTypes: "Gerätetypen",
          parametersTracked: "Verfolgte Parameter",
          automationRules: "Automatisierungsregeln",
        },
      },
      lifecycle: {
        title: "Geräte-Lebenszyklusmanagement",
        description:
          "Begleiten Sie den gesamten Prozess von der Geräteanmeldung bis zu intelligenter Analyse mit JUHUU Digital Twins",
        play: "Abspielen",
        pause: "Pause",
        reset: "Zurücksetzen",
        step: "Schritt",
        keyActions: "Wichtige Aktionen in diesem Schritt:",
        steps: [
          {
            title: "Onboarden",
            description: "Neue Hardware im JUHUU Dashboard registrieren",
            details:
              "Digitale Datensätze für Ihre physischen Geräte mit benutzerdefinierten Datenfeldern und Befehlen erstellen.",
            actions: [
              "Gerät in Dashboard › Digital Twins registrieren",
              "Eindeutige Kennungen und Metadaten vergeben",
              "Benutzerdefinierte Felder und erlaubte Befehle definieren",
            ],
          },
          {
            title: "Konfigurieren",
            description:
              "UI-Layouts und Step-Chains mit dem visuellen Builder designen",
            details:
              "Drag-and-drop-Tools verwenden, um benutzerdefinierte Interfaces und Automatisierungsregeln für Ihre Geräte zu erstellen.",
            actions: [
              "Gerätespezifische UI-Layouts entwerfen",
              "Step-Chains mit dem visuellen Builder erstellen",
              "Parameter und Datentypen definieren",
              "Trigger und Automatisierungsregeln einrichten",
            ],
          },
          {
            title: "Bereitstellen",
            description:
              "Zwilling veröffentlichen; Logik synchronisiert automatisch",
            details:
              "Konfiguration des digitalen Zwillings nahtlos über Cloud, App und Edge-Geräte verteilen.",
            actions: [
              "Digitale-Zwilling-Konfiguration veröffentlichen",
              "Logik mit Cloud-Infrastruktur synchronisieren",
              "In JUHUU App Interfaces ausrollen",
              "Auf kompatible Edge-Geräte übertragen",
            ],
          },
          {
            title: "Betreiben",
            description:
              "Live-Parameter aktualisieren sich kontinuierlich; Nutzer interagieren über individuelles UI",
            details:
              "Überwachen Sie den Gerätestatus in Echtzeit und ermöglichen Sie Benutzerinteraktionen über Ihre individuellen Interfaces.",
            actions: [
              "Live-Parameter überwachen",
              "Benutzerinteraktionen über individuelles UI ermöglichen",
              "Step-Chains automatisch ausführen",
              "Gerätebefehle in Echtzeit verarbeiten",
            ],
          },
          {
            title: "Analysieren",
            description:
              "Historische Parameterdaten fließen in die KI-Anomalieerkennung",
            details:
              "Nutzen Sie historische Daten für vorausschauende Erkenntnisse und proaktive Gerätewartung.",
            actions: [
              "Historische Parameterdaten sammeln",
              "Daten an KI-Anomalieerkennung übertragen",
              "Prädiktive Erkenntnisse generieren",
              "Proaktives Alerting einrichten",
            ],
          },
        ],
      },
      parameters: {
        title: "Parameterverwaltung",
        description:
          "Plattformweite Parameter speichern Live-Zustände bei vollständiger Historie für Monitoring, Dashboards und Analysen",
        supportedTypes: "Unterstützte Datentypen",
        exampleUsage: "Beispielverwendung:",
        featuresTitle: "Schlüssel-Funktionen",
        viewDashboard: "Gesamtes Dashboard anzeigen",
        dashboardTitle: "Live-Parameter-Dashboard",
        dashboardDescription:
          "Echtzeitüberwachung der Geräteparameter Ihrer gesamten Flotte",
        cards: {
          batteryLevel: "Batteriestand",
          doorStatus: "Türstatus",
          temperature: "Temperatur",
          operationMode: "Betriebsmodus",
          lastUpdated: "Zuletzt aktualisiert: {{time}}",
        },
        types: {
          string: {
            name: "String",
            description:
              "Textbasierte Parameter für Statusmeldungen, Gerätenamen und Beschreibungen",
            example: "device_status = 'operational'",
          },
          float: {
            name: "Number",
            description:
              "Dezimalzahl-Parameter für präzise Messungen und Berechnungen",
            example: "tire_pressure = 2.3",
          },
          boolean: {
            name: "Boolean",
            description:
              "True/False-Parameter für Schalter, Schlösser und binäre Zustände",
            example: "door_locked = true",
          },
          enum: {
            name: "Enum",
            description:
              "Vordefinierte Listenparameter für Modi, Zustände und Kategorien",
            example: "mode = 'eco' | 'normal' | 'sport'",
          },
        },
        features: {
          visibility: {
            title: "Lese-/Schreib-Sichtbarkeit",
            description:
              "Parameter sind in Step-Chains, UI-Layouts und HTTP-Hooks verfügbar",
            benefits: [
              "Echtzeit-Datenzugriff in allen Plattformkomponenten",
              "Nahtlose Integration in die Automatisierungslogik",
              "API-Endpunkte für die Anbindung externer Systeme",
            ],
          },
          history: {
            title: "Automatische Historie",
            description:
              "Zeitreihen-Speicherung jeder Parameteränderung mit vollständigem Audit-Trail",
            benefits: [
              "Vollständige Historie aller Daten",
              "Trendanalysen und Mustererkennung",
              "Erfüllung von Compliance-Anforderungen",
            ],
          },
          analytics: {
            title: "Analytics-Integration",
            description:
              "Direkte Anbindung an KI-Anomalie-Dashboards für Einblicke",
            benefits: [
              "Vorausschauende Wartung",
              "Anomalieerkennung und Alarmierung",
              "Leistungsoptimierungs-Insights",
            ],
          },
        },
      },
      quickStart: {
        title: "Schnellstart-Anleitung",
        description:
          "Bringen Sie Ihren ersten digitalen Zwilling in weniger als 15 Minuten zum Laufen – Schritt für Schritt",
        setupSteps: "Setup-Schritte",
        progress: "Fortschritt",
        of: "von {{total}}",
        stepLabel: "Schritt {{step}}",
        previous: "Vorheriger Schritt",
        next: "Nächster Schritt",
        complete: "Setup abschließen",
        whatToDo: "Was ist zu tun:",
        proTips: "Profi-Tipps:",
        steps: [
          {
            title: "Gerät hinzufügen",
            description:
              "Registrieren Sie Ihr erstes Gerät im Digital-Twins-Dashboard",
            action:
              "Navigieren Sie zu Dashboard › Digital Twins und klicken Sie auf 'Neues Gerät hinzufügen'",
            tips: [
              "Wählen Sie einen beschreibenden Gerätenamen",
              "Passende Gerätekategorie auswählen (E-Scooter, Schließfach, etc.)",
              "Standortinformationen für bessere Flottenverwaltung hinzufügen",
            ],
          },
          {
            title: "Parameter definieren",
            description:
              "Legen Sie die Datenfelder und Befehle Ihres Geräts fest",
            action:
              "Definieren Sie Parameter (battery_level, door_status, etc.) und zulässige Befehle (unlock, lock, etc.)",
            tips: [
              "Beginnen Sie mit wichtigen Parametern wie Status und Batteriestand",
              "Verwenden Sie klare, beschreibende Parameternamen",
              "Wählen Sie passende Datentypen für jeden Parameter",
            ],
          },
          {
            title: "UI-Layout erstellen",
            description:
              "Gestalten Sie die Benutzeroberfläche zur Geräteinteraktion",
            action:
              "Nutzen Sie den visuellen Editor, um Buttons, Schalter und Statusanzeigen für Ihr Gerät anzulegen",
            tips: [
              "Halten Sie die Oberfläche einfach und intuitiv",
              "Gruppieren Sie zusammengehörige Bedienelemente",
              "Nutzen Sie bedingte Sichtbarkeit für erweiterte Funktionen",
            ],
          },
          {
            title: "Step-Chain bauen",
            description:
              "Automatisierungsregeln für das Geräteverhalten erstellen",
            action:
              "Erstellen Sie mindestens eine Step-Chain, um das Verhalten Ihres Geräts bei Ereignissen zu definieren",
            tips: [
              "Beginnen Sie mit einfachen Trigger-Action-Paaren",
              "Testen Sie jede Step-Chain gründlich",
              "Berücksichtigen Sie Sonderfälle und Fehlerbehandlung",
            ],
          },
          {
            title: "Veröffentlichen & überwachen",
            description: "Digitalen Zwilling deployen und Monitoring starten",
            action:
              "Kompatible JUHUU Hardware anbinden (optional), Konfiguration veröffentlichen und Live-Daten überwachen",
            tips: [
              "Beobachten Sie die ersten Interaktionen genau",
              "Optimieren Sie Step-Chains anhand der realen Nutzung",
              "Nutzen Sie die Analytics zur Leistungsoptimierung",
            ],
          },
        ],
      },
    },
    dashboard: {
      page: {
        heroBadge: "JUHUU Dashboard · Für Betreiber:innen",
        heroTitleLine1: "Verwalte dein",
        heroTitleLine2Prefix: "Geschäft an",
        heroTitleHighlight: "einem Ort",
        heroDescription:
          "Als Betreiber:in steuerst du Vermietungen, Standorte, Produkte, Tarife und Abrechnung über ein einziges Dashboard — mit Echtzeit-Überblick über alles, was gerade vor sich geht.",
        ctaBookDemo: "Demo buchen",
        ctaLogin: "Zum Login",
        mockTitle: "Dashboard",
        mockWelcome:
          "Willkommen zurück! Das passiert gerade in deinem Geschäft.",
        navHome: "Home",
        navQuickActions: "Quick Actions",
        navBikeBoxes: "BikeBoxes",
        navCalendar: "Kalender",
        navTransactions: "Transaktionen",
        navMap: "Karte",
        navOperators: "Operators",
        navBooking: "Buchungen",
        navBilling: "Abrechnung",
        navSupport: "Support",
        kpis: [
          { label: "Umsatz (7 Tage)", value: "3.000 €", delta: "▲ 69,4 %" },
          { label: "Vermietungen (7 T.)", value: "12", delta: "▲ 33,3 %" },
          { label: "Aktive Geräte", value: "318", delta: "6 offline" },
          { label: "Auslastung", value: "74 %", delta: "Ø 7 Tage" },
        ],
        incidentsTitle: "Offene Vorfälle",
        incidentsOverview: "Übersicht",
        incidentAwaiting: "Bestätigung offen",
        incidentLow: "Niedrig",
        incidents: [
          { name: "Fahrradbox 3 | E-MTB Hardtail", date: "30.05.2026, 10:40" },
          { name: "Fahrradbox 2 | E-MTB Hardtail", date: "30.05.2026, 10:37" },
          { name: "Fahrradbox 1 | E-MTB Hardtail", date: "28.04.2026, 08:09" },
        ],
        capKicker: "Funktionsumfang",
        capTitleLine1: "Eine Steuerzentrale.",
        capTitleLine2: "Alles im Griff.",
        capLead:
          "Jedes Modul, das du als Betreiber:in brauchst, in einer Oberfläche, ohne Tool-Wechsel.",
        caps: [
          {
            title: "Vermietungen verwalten",
            description:
              "Buchungen und Reservierungen als Timeline oder Tabelle anlegen, exportieren und im Blick behalten.",
          },
          {
            title: "Geräteverwaltung",
            description:
              "Status & Historie verfolgen und Hardware fernsteuern, öffnen, sperren, zurücksetzen.",
          },
          {
            title: "Standorte, Produkte & QR-Codes",
            description:
              "Standorte und Produkte pflegen, QR-Codes ausgeben und alles auf der Karte sehen.",
          },
          {
            title: "Tarife & Pay-as-you-go",
            description:
              "Preise nach Dauer und Höchstbetrag definieren von pro Minute bis Jahresmiete.",
          },
          {
            title: "Abrechnung & Buchungskreise",
            description:
              "Transaktionen einsehen, Rechnungen automatisieren und Umsätze sauber zuordnen.",
          },
          {
            title: "Benefit Cards & Rabatte",
            description:
              "Rabattcodes und vergünstigte Tarife vergeben und externe Systeme wie ÖPNV anbinden.",
          },
          {
            title: "Kund:innen verwalten",
            description:
              "Kundenkonten suchen, einsehen und verwalten inklusive Verifizierungsstatus.",
          },
          {
            title: "Vorfälle überwachen",
            description:
              "Offene Vorfälle nach Status und Dringlichkeit sehen und sofort bearbeiten.",
          },
        ],
        bookingKicker: "Buchungen",
        bookingTitleLine1: "Jede Vermietung",
        bookingTitleLine2: "auf einen Blick.",
        bookingDescription:
          "Verwalte alle Mietvorgänge und Reservierungen für deine Standorte als Timeline oder Tabelle, gefiltert nach Standort, farblich nach Status.",
        bookingBullets: [
          "Status: Reservierung, aktiv, anstehend, offen, abgeschlossen",
          "Neue Mieten manuell anlegen",
          "Mit einem Klick exportieren",
        ],
        mockRentals: "Vermietungen",
        mockRentalBtn: "Miete",
        chipTimeline: "Timeline",
        chipTable: "Tabelle",
        chipAllLocations: "Alle Standorte ▾",
        legendActive: "Aktiv",
        legendUpcoming: "Anstehend",
        legendPending: "Offen",
        timelineLocation: "LOCATION",
        devicesKicker: "Geräteverwaltung",
        devicesTitleLine1: "Deine Hardware,",
        devicesTitleLine2: "aus der Ferne im Griff.",
        devicesDescription:
          "Verfolge den Status jedes Geräts in Echtzeit, sieh dir die komplette Historie an und steuere die Hardware direkt aus dem Dashboard alles, was du zur Verwaltung deiner Geräte brauchst.",
        devicesBullets: [
          "Online-/Offline-Status & Geräte-Historie",
          "Fernsteuern: öffnen, sperren, zurücksetzen",
          "IoT-Geräte registrieren & konfigurieren",
        ],
        mockDevices: "Geräte",
        mockCreateDevice: "Gerät anlegen",
        mockDevicesLead:
          "Status überwachen, Historie einsehen und Geräte fernsteuern.",
        tableName: "Name",
        tableStatus: "Status",
        tableAction: "Aktion",
        statusOnline: "Online",
        statusOffline: "Offline",
        openBox: "Box öffnen",
        tariffsKicker: "Abrechnung",
        tariffsTitleLine1: "Tarife, die du",
        tariffsTitleLine2: "selbst bestimmst.",
        tariffsDescription:
          "Definiere Preise nach Dauer und Höchstbetrag vom Pay-as-you-go-Tarif pro Minute bis zur Jahresmiete. Die Abrechnung läuft danach vollautomatisch.",
        tariffsBullets: [
          "Pay-as-you-go, Tages-, Monats- & Jahrestarife",
          "Automatische Rechnungen & Transaktionen",
          "Zuordnung zu Buchungskreisen",
        ],
        mockTariffs: "Tarife",
        mockCreate: "Erstellen",
        mockTariffsLead:
          "Lege Preise für die Services fest, die du anbietest.",
        tableDuration: "Dauer",
        tableMaxAmount: "Höchstbetrag",
        tariffRows: [
          { name: "Pay-as-you-go", duration: "pro Minute", amount: "0,15 €/min" },
          { name: "Tagesmiete", duration: "5 Min", amount: "25,00 €" },
          { name: "2-Tage-Miete", duration: "1 Tag 2 Std", amount: "48,00 €" },
          { name: "Jahresmiete", duration: "365 Tage", amount: "180,00 €" },
        ],
        customersKicker: "Kund:innen & Benefit Cards",
        customersTitleLine1: "Deine Kund:innen.",
        customersTitleLine2: "Deine Konditionen.",
        customersDescription:
          "Verwalte alle Kundenkonten an einem Ort und vergib Benefit Cards mit Rabatten oder vergünstigten Tarifen. So lassen sich auch externe Systeme wie ÖPNV-Anbieter anbinden und eigene Konditionen abbilden.",
        customersBullets: [
          "Kundenkonten suchen, einsehen & verwalten",
          "Rabattcodes & günstigere Tarife per Benefit Card",
          "Externe Systeme wie ÖPNV-Anbieter anbinden",
        ],
        mockCustomers: "Kund:innen",
        mockUserBtn: "Nutzer:in",
        mockSearchPlaceholder: "Kund:innen suchen…",
        mockSearchBtn: "Suchen",
        tableEmail: "E-Mail",
        tableVerified: "Verifiziert",
        customKicker: "Maßgeschneidert",
        customTitleLine1: "Custom Dashboards",
        customTitleLine2: "für jeden Use Case.",
        customDescription:
          "Wir richten dir individuelle Dashboards ein, die nur das zeigen, was zählt, zugeschnitten auf deinen Anwendungsfall.",
        customBullets: [
          "Rollen- & teamspezifische Ansichten",
          "Nur die relevanten Module, kein Ballast",
          "Von uns auf deinen Use Case optimiert",
        ],
        mockSupportView: "Support-Ansicht",
        mockCustomBadge: "Custom",
        chipSupport: "Support",
        chipAccounting: "Buchhaltung",
        chipOperations: "Betrieb",
        customNote:
          "Nur 3 Module sichtbar — auf den Support-Use-Case reduziert.",
        customTiles: [
          { label: "Mieten", value: "12", sub: "heute" },
          { label: "Kund:innen", value: "1.284", sub: "gesamt" },
          { label: "Geräte", value: "318", sub: "online" },
        ],
        recentRentals: "Letzte Mieten",
        recentRows: [
          { name: "Mara Weiß · BikeBox 04", status: "aktiv" },
          { name: "Tobias Frank · Box 01", status: "offen" },
        ],
        stats: [
          { value: "90%", label: "weniger Verwaltungsaufwand" },
          { value: "24/7", label: "Echtzeit-Überblick" },
          { value: "1", label: "Dashboard für alles" },
        ],
        trustedBy: "Im Einsatz für",
        finalCtaTitle: "Mehr aus deinem Geschäft holen.",
        finalCtaDescription:
          "Finde heraus wie Betreiber mit dem JUHUU Dashboard arbeiten und lass dir alles in einer persönlichen Tour zeigen.",
        finalCtaButton: "Demo buchen",
      },
      heroTitle: "Unternehmens-Dashboard",
      heroHighlight: "Analysen & Kontrolle.",
      heroDescription:
        "Das umfassende JUHUU-Dashboard gibt Ihnen die volle Kontrolle über Ihr digitales Ökosystem. Überwachen Sie Leistungen, verwalten Sie Geräte, verfolgen Sie Finanzen und optimieren Sie Abläufe – alles in einer intuitiven Oberfläche.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      realTimeMetrics: "Echtzeitmetriken",
      customizableViews: "Anpassbare Ansichten",
      aiPoweredInsights: "KI-gestützte Einblicke",
      billing: {
        tag: "JUHUU Billing Engine",
        title: "Leistungsstarkes Finanzmanagement",
        description:
          "Unser umfassendes Abrechnungssystem bietet volle Kontrolle über Ihre Finanzprozesse mit flexiblen Preismodellen, automatisierten Rechnungen und detaillierten Reports.",
        overviewTitle: "Umfassender Finanzüberblick",
        overviewDescription:
          "Erhalten Sie einen vollständigen Überblick über Ihre finanzielle Performance mit detaillierten Einblicken in Einnahmen, Zahlungsstatus und Trends.",
        revenueAnalyticsTitle: "Umsatzanalysen",
        revenueAnalyticsDesc:
          "Verfolgen Sie alle Einnahmequellen und identifizieren Sie Wachstumspotenziale mit detaillierten Finanzberichten.",
        paymentTrackingTitle: "Zahlungsverfolgung",
        paymentTrackingDesc:
          "Überwachen Sie Zahlungsstatus, Rechnungen und Transaktionshistorie in Echtzeit.",
        financialReportingTitle: "Finanzberichte",
        financialReportingDesc:
          "Erstellen Sie individuelle Berichte und exportieren Sie Finanzdaten für Buchhaltung und Analyse.",
        rentalsTitle: "Verwaltung von Mieten und Reservierungen",
        rentalsDescription:
          "Beobachten Sie alle aktiven Mieten und bevorstehenden Reservierungen in Echtzeit mit detaillierten Finanzinformationen zu jeder Transaktion.",
        activeRentalTitle: "Aktive Mietverfolgung",
        activeRentalDesc:
          "Sehen Sie alle aktiven Mieten, deren Status und zugehörige Umsätze in einem Dashboard.",
        reservationManagementTitle: "Reservierungsverwaltung",
        reservationManagementDesc:
          "Verwalten Sie kommende Reservierungen, nehmen Sie Änderungen vor und optimieren Sie die Ressourcenauslastung.",
        usageStatisticsTitle: "Nutzungsstatistiken",
        usageStatisticsDesc:
          "Analysieren Sie Nutzungsmuster, um Bestände zu optimieren und das Kundenerlebnis zu verbessern.",
        tariffTitle: "Flexibles Tarifmanagement",
        tariffDescription:
          "Erstellen und verwalten Sie flexible Preismodelle – von zeitbasierter Abrechnung über Abos bis hin zu dynamischen Preisen.",
        customPricingTitle: "Individuelle Preisstrukturen",
        customPricingDesc:
          "Entwerfen und implementieren Sie Preisstrukturen, die genau auf Ihre Geschäftsanforderungen zugeschnitten sind.",
        subscriptionManagementTitle: "Aboverwaltung",
        subscriptionManagementDesc:
          "Richten Sie wiederkehrende Zahlungspläne mit automatischer Rechnungsstellung und Zahlungsabwicklung ein und verwalten Sie diese.",
        locationSpecificTitle: "Standortabhängige Tarife",
        locationSpecificDesc:
          "Weisen Sie jedem Standort und Gerät individuelle Tarife für maximale Flexibilität zu.",
        summary:
          "Die JUHUU Billing Engine bietet alle Werkzeuge, um Ihre Finanzprozesse effizient und effektiv zu steuern.",
        learnMore: "Mehr über Billing Engine",
      },
      management: {
        tag: "Management-Dashboard",
        title: "Leistungsstarke Management-Tools",
        description:
          "Behalten Sie mit unserem umfassenden Management-Dashboard die Kontrolle über Ihr Unternehmen – mit Echtzeit-Einblicken und leistungsstarken Werkzeugen.",
        realTimeAnalyticsTitle: "Echtzeitanalysen",
        realTimeAnalyticsDesc:
          "Überwachen Sie Leistungskennzahlen, verfolgen Sie Nutzungsmuster und erkennen Sie Wachstumspotenziale mit umfassenden Analysedashboards.",
        financialManagementTitle: "Finanzmanagement",
        financialManagementDesc:
          "Vereinfachen Sie Rechnungsstellung, verfolgen Sie Einnahmeströme und verwalten Sie Auszahlungen über mehrere Geschäftseinheiten oder Länder hinweg.",
        monthlyRevenue: "Monatsumsatz",
        activeUsers: "Aktive Nutzer",
      },
      device: {
        statusTitle: "Gerätestatus",
        onlineCount: "{{count}} online",
        offlineCount: "{{count}} offline",
        addDevice: "Gerät hinzufügen",
        table: {
          device: "Gerät",
          status: "Status",
          lastUsed: "Zuletzt genutzt",
          battery: "Batterie",
          location: "Standort",
        },
        online: "Online",
        offline: "Offline",
        oneHourAgo: "vor 1 Stunde",
        tenMinutesAgo: "vor 10 Minuten",
        thirtyMinutesAgo: "vor 30 Minuten",
        fiveMinutesAgo: "vor 5 Minuten",
        acPower: "Netzstrom",
        locationBerlin: "Berlin Zentrum",
        locationMunich: "München Bahnhof",
        locationHamburg: "Hamburger Hafen",
        locationFrankfurt: "Frankfurt Innenstadt",
        sectionTag: "Gerätemanagement",
        sectionTitle: "Geräteverwaltung vereinfachen und Interfaces anpassen",
        sectionDescription:
          "Betreiber können wichtige Geräteparameter einsehen, eigene Interfaces erstellen und Geräte per Drag-and-Drop programmieren. Außerdem lassen sich SIM-Karten verwalten und die Verbindungen jedes Geräts überwachen.",
        simManagementTitle: "SIM-Verwaltung",
        simManagementDesc:
          "Verwalten Sie SIM-Karten Ihrer Geräte mit automatischer Bereitstellung und Überwachung.",
        templatesTitle: "Gerätevorlagen",
        templatesDesc:
          "Erstellen Sie individuelle Interfaces und bearbeiten Sie Code direkt mit unserem intuitiven Vorlagensystem.",
        digitalTwinsTitle: "Digitale Zwillinge",
        digitalTwinsDesc:
          "Erhalten Sie einen Echtzeit-Überblick über Ihre Geräte mittels digitaler Zwillinge, die den physischen Status widerspiegeln.",
        connectorsTitle: "Connectors",
        connectorsDesc:
          "Verwalten Sie die Konnektivität Ihrer Infrastruktur mit unseren leistungsstarken Connection-Tools.",
      },
      docs: {
        tag: "Wissensmanagement",
        title: "JUHUU Docs & Buddy",
        description:
          "Erstellen, verwalten und verteilen Sie Wissen in Ihrem Unternehmen und an Ihre Kunden mit unserem intelligenten Dokumentationssystem und dem KI-gestützten Assistenten.",
        docsTitle: "JUHUU Docs",
        docsDescription:
          "Erstellen und verwalten Sie umfassende Dokumentationen zu Produkten, Services und FAQs direkt im Dashboard. Unser intelligentes System übersetzt Inhalte automatisch in mehrere Sprachen und stellt sie Ihren Kunden und dem JUHUU Buddy bereit.",
        editorTitle: "Dokumentations-Editor",
        multilingualTitle: "Mehrsprachigkeit",
        multilingualDesc:
          "KI-gestützte Übersetzung wandelt Ihre Dokumentation automatisch in mehrere Sprachen um.",
        versionControlTitle: "Versionskontrolle",
        versionControlDesc:
          "Verfolgen Sie Änderungen, verwalten Sie Revisionen und stellen Sie bei Bedarf frühere Versionen wieder her.",
        knowledgeIntegrationTitle: "Knowledge-Base-Integration",
        knowledgeIntegrationDesc:
          "Verbinden Sie Ihre Dokumentation nahtlos mit dem JUHUU Buddy für intelligenten Kundensupport.",
        buddyTitle: "JUHUU Buddy",
        buddyDescription:
          "Ihr KI-gestützter Assistent nutzt Ihre Dokumentation, um Kunden sofort und präzise zu unterstützen. JUHUU Buddy lernt aus Ihrer Wissensbasis und verbessert seine Antworten kontinuierlich durch Kundenfeedback.",
        buddyConfigTitle: "Buddy-Konfiguration",
        buddyKnowledgeTitle: "Wissensintegration",
        buddyKnowledgeDesc:
          "Trainieren Sie Ihren Buddy mit Ihrer spezifischen Dokumentation, um genaue und kontextbezogene Antworten zu liefern.",
        buddyContinuousTitle: "Stetiges Lernen",
        buddyContinuousDesc:
          "Der Buddy verbessert sich im Laufe der Zeit durch das Lernen aus Kundeninteraktionen und Feedback.",
        buddyMultilingualTitle: "Mehrsprachiger Support",
        buddyMultilingualDesc:
          "Kommunizieren Sie mit Kunden in ihrer bevorzugten Sprache dank Echtzeitübersetzung.",
        ctaText:
          "Stärken Sie Ihr Team und Ihre Kunden mit intelligenter Dokumentation und KI-gestütztem Support, der sich kontinuierlich verbessert.",
        exploreBuddy: "JUHUU Buddy entdecken",
        exploreDocs: "JUHUU Docs entdecken",
      },
    },
    designYourOwn: {
      heroTitle: "Gestalten Sie Ihren eigenen",
      heroHighlight: "Anwendungsfall",
      heroDescription:
        "Mit unserem modularen Baukastensystem digitalisieren Sie jede Idee in nur wenigen Tagen – von Bike- und Scooter-Sharing bis hin zu Smart-Parking-Plattformen. Keine monatelangen Sonderentwicklungen nötig.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Loslegen",
      badges: {
        fastDeployment: "Schnelle Bereitstellung",
        modularDesign: "Modulares Design",
        aiEnhanced: "KI-unterstützt",
      },
      cardTitles: {
        modularDesign: "Modulares Design",
        rapidIntegration: "Schnelle Integration",
        timeToMarket: "Time-to-Market",
        provenSolution: "Bewährte Lösung",
        fasterLaunch: "Bis zu 70% schneller am Markt",
      },
      introTitle: "Ihr individueller Use Case – in Rekordzeit umgesetzt",
      introDescription:
        "JUHUU bietet Ihnen die Flexibilität, Ihre eigene Mobilitätslösung zu gestalten, ohne bei Null zu beginnen. Nutzen Sie unsere erprobten Module und sparen Sie wertvolle Entwicklungszeit mit unserer Plug-and-Play-Integration.",
      features: {
        modularBlocksTitle: "Modulare Bausteine",
        modularBlocksDesc:
          "Wählen Sie genau die Funktionen, die Sie benötigen – von Nutzermanagement über Zahlungsabwicklung bis hin zur IoT-Integration, alles über einfache API-Anbindungen.",
        seamlessIntegrationTitle: "Nahtlose Integration",
        seamlessIntegrationDesc:
          "Dank standardisierter APIs und SDKs binden Sie Ihre Hardware und Systeme in kürzester Zeit über unsere One-Click-Connectoren an.",
        whiteLabelTitle: "White-Label-Lösung",
        whiteLabelDesc:
          "Passen Sie das Erscheinungsbild vollständig an Ihre Marke an – von der App bis zu Support-Oberflächen mit unserem intuitiven Designsystem.",
      },
      integration: {
        title: "Integration leicht gemacht",
        description:
          "Unsere Plattform ist für die nahtlose Einbindung in Ihre bestehenden Systeme und Hardware ausgelegt. Verbinden Sie sich in Minuten statt Monaten.",
        list: {
          oneClickTitle: "One-Click-Geräteanbindung",
          oneClickDesc: "Neue Geräte per einfachem Scan zur Flotte hinzufügen",
          preBuiltTitle: "Vorgefertigte API-Connectoren",
          preBuiltDesc: "Fertige Integrationen für gängige Dienste",
          noCodeTitle: "No-Code-Konfiguration",
          noCodeDesc: "Komplexe Workflows ohne Programmierung einrichten",
        },
        statusTitle: "Integrationsstatus",
        statusDesc: "Alle Systeme verbunden",
        active: "Aktiv",
        items: {
          paymentGateway: "Zahlungs-Gateway",
          mobileApp: "Mobile App",
          securityModule: "Sicherheitsmodul",
          userManagement: "Benutzerverwaltung",
          connected: "Verbunden",
        },
        addButton: "Neue Integration hinzufügen",
      },
      process: {
        title: "Ihr Use Case in 4 einfachen Schritten",
        step1Title: "Idee & Ziele definieren",
        step1Desc:
          "Führen Sie Interviews mit Zielgruppen, dokumentieren Sie Pain Points und formulieren Sie Ihr Use-Case-Statement. Unser Team hilft bei der Feinabstimmung Ihrer Anforderungen.",
        step1Tags: [
          "Anforderungsanalyse",
          "Zielgruppendefinition",
          "Marktanalyse",
        ],
        step2Title: "Module auswählen",
        step2Desc:
          "Wählen Sie genau die Komponenten aus unserem modularen Technologie-Baukasten, die Sie benötigen – von Nutzer-Apps über Operator-Dashboards bis hin zu IoT-Integration und Zahlungsabwicklung.",
        step2Tags: [
          "Modulauswahl",
          "Technische Spezifikation",
          "Architekturplanung",
        ],
        step3Title: "Implementierung",
        step3Desc:
          "Integrieren Sie Hardware, konfigurieren Sie das Dashboard und passen Sie das Frontend-Branding an. Unser Expertenteam begleitet Sie mit One-Click-Integrationstools durch den gesamten Prozess.",
        step3Tags: [
          "Hardware-Integration",
          "Branding",
          "Konfiguration",
          "Testing",
        ],
        step4Title: "Pilot & Rollout",
        step4Desc:
          "Starten Sie mit einer kleinen Flotte, sammeln Sie Feedback und skalieren Sie anschließend Ihren Rollout. Unsere Plattform wächst mit Ihren Anforderungen und passt sich an.",
        step4Tags: [
          "Pilotprojekt",
          "Feedback-Analyse",
          "Skalierung",
          "Kontinuierliche Optimierung",
        ],
      },
      ecosystem: {
        title: "JUHUU Produkt-Ökosystem",
        description:
          "Unsere umfassende Produktsuite greift nahtlos ineinander, um Ihren individuellen Use Case zu realisieren",
        coreTitle: "Kerninfrastruktur",
        core: {
          digitalTwinsTitle: "Digital Twins",
          digitalTwinsDesc: "Virtuelle Abbilder all Ihrer physischen Geräte",
          identityTitle: "Identity",
          identityDesc: "Sichere Authentifizierung und Benutzerverwaltung",
          specialDevTitle: "Special Development",
          specialDevDesc:
            "Individuelle Integrationsservices für komplexe Fälle",
          strataTitle: "Strata",
          strataDesc: "Self-Service-Integrationsplattform",
          comingSoon: "Demnächst",
        },
        uiTitle: "Benutzeroberflächen",
        ui: {
          appTitle: "App",
          appDesc: "Native mobile Apps für iOS und Android",
          webAppTitle: "WebApp",
          webAppDesc: "Browserbasierte Buchungs- und Verwaltungsoberfläche",
          mapTitle: "Karte",
          mapDesc: "Interaktive ortsbasierte Dienste und Visualisierung",
          whitelabelTitle: "Whitelabel",
          whitelabelDesc: "Vollständig gebrandete Anwendungen",
        },
        opsTitle: "Betrieb & Business",
        ops: {
          dashboardTitle: "Dashboard",
          dashboardDesc: "Umfassende Verwaltungs- und Analysekonsole",
          billingTitle: "Billing",
          billingDesc: "Zahlungsabwicklung, Rechnungsstellung und Finanzen",
          marketplaceTitle: "Marketplace",
          marketplaceDesc: "Zertifizierte Hardware und Services integrieren",
          buddyTitle: "Buddy",
          buddyDesc: "KI-gestützter Support und Assistance",
        },
      },
      productsTogetherTitle: "Wie unsere Produkte zusammenspielen",
      todayTitle: "Heute: Special Development",
      todayDesc:
        "Aktuell arbeiten wir direkt mit Kunden zusammen, um ihre individuellen Use Cases über unseren Special-Development-Service umzusetzen. Unser Expertenteam übernimmt die Integration Ihrer Systeme in unsere Plattform.",
      todayBenefitsTitle: "Vorteile:",
      todayBenefits: [
        "Vollständig maßgeschneiderte Lösungen",
        "Fachkundige Begleitung während des gesamten Prozesses",
        "Schnelle Umsetzung durch unser erfahrenes Team",
      ],
      futureTitle: "Zukunft: Strata Plattform",
      futureDesc:
        "Schon bald ermöglicht unsere Strata Plattform die eigenständige Umsetzung von Use Cases. Sie wählen zwischen No-Code-, Low-Code- oder Expert-Integrationspfaden – ganz nach Bedarf.",
      futureBenefitsTitle: "Vorteile:",
      futureBenefits: [
        "Self-Service-Integration",
        "No-Code-, Low-Code- und Expert-Optionen",
        "Volle Kontrolle über die Umsetzung",
      ],
      uspTitle: "Warum JUHUU",
      usps: {
        speedTitle: "Geschwindigkeit & Skalierbarkeit",
        speed1:
          "Plug-and-Play-Onboarding: Zertifizierte Geräte in Tagen einbinden – über No-Code-, Low-Code- und Expert-Integrationen",
        speed2:
          "Modulare Wachstumsbausteine: Jedes neue Produkt baut auf derselben Basis auf und verursacht keine zusätzliche Komplexität",
        flexibilityTitle: "Flexibilität & Kontrolle",
        flexibility1:
          "Drei Integrationsstufen: Wählen Sie den Aufwand – schlüsselfertig, visuelle Konfiguratoren oder tiefe APIs für eigene Logik",
        flexibility2:
          "White-Label-Branding: Nutzen Sie die universelle JUHUU App oder starten Sie eine vollständig private Whitelabel-Hülle",
        growthTitle: "Wachstum & Monetarisierung",
        growth1:
          "Betreiberanreize: Revenue Share (15%) und User-Referral-Programme machen Partner zu Vermarktern",
        growth2:
          "Hochmargige Add-ons: Plus-Abos, Affiliate-Links und integrierte Bookables erschließen neue Einnahmequellen",
        efficiencyTitle: "Betriebliche Effizienz",
        efficiency1:
          "End-to-End-Flow: Vom Gerätedaten über Billing Engine, Identity und Dashboard – ein einheitliches Datenmodell",
        efficiency2:
          "Predictive Maintenance: Anomalie-Erkennung meldet Ausfälle frühzeitig und reduziert ungeplante Ausfallzeiten um bis zu 30%",
      },
      components: {
        appDescription: {
          heading: "Eine Plattform, viele Lösungen",
          description:
            "JUHUU verbindet Nutzer mit Dienstanbietern über eine nahtlose, integrierte Plattform für Mobilität, Infrastruktur und Versorgungsleistungen.",
          forUsers: {
            title: "Für Nutzer",
            description:
              "Finden, buchen und nutzen Sie Services verschiedener Anbieter an einem Ort. JUHUU vereint ein breites Spektrum an Mobilitäts-, Infrastruktur- und Versorgungsdiensten in einer einzigen, leicht zu bedienenden App.",
            features: [
              {
                title: "Service-Entdeckung",
                description:
                  "Finden Sie verfügbare Dienste in Ihrer Nähe in Echtzeit",
              },
              {
                title: "Einfache Bezahlung",
                description: "Buchen und bezahlen Sie nahtlos in der App",
              },
              {
                title: "Einheitlicher Zugang",
                description:
                  "Greifen Sie mit einem Konto auf Services verschiedener Anbieter zu",
              },
              {
                title: "Globale Abdeckung",
                description:
                  "Nutzen Sie dieselbe App in mehreren Städten und Ländern",
              },
            ],
          },
          forProviders: {
            title: "Für Anbieter",
            description:
              "Erreichen Sie mehr Kunden und optimieren Sie Ihre Abläufe. JUHUU stellt Dienstanbietern die Werkzeuge bereit, um ihre Produkte und Services einem größeren Publikum anzubieten.",
            features: [
              {
                title: "Große Nutzerbasis",
                description:
                  "Zugriff auf eine wachsende Gemeinschaft aktiver Nutzer",
              },
              {
                title: "Vertriebskanal",
                description: "Direkter Vertriebskanal für all Ihre Services",
              },
              {
                title: "Whitelabeling",
                description:
                  "Integration der Corporate Identity innerhalb der App",
              },
              {
                title: "JUHUU Services",
                description:
                  "Direkter Zugang zu tief integrierten JUHUU-Services",
              },
            ],
          },
          cta: "Mit JUHUU loslegen",
        },
      },
    },
    bikeSharing: {
      heroTitle: "Anwendungsfall: Bikesharing",
      backToOverview: "\u2190 Zur\u00fcck zur \u00dcbersicht",
      intro:
        "Starten und verwalten Sie einen kompletten Bike-Sharing-Service mit unserer End-to-End-Lösung. JUHUU bietet alles, was Sie brauchen: Benutzer-Apps, Betreiber-Dashboards und Zahlungsabwicklung.",
      underConstructionTitle: "Diese Seite ist in Bearbeitung",
      underConstructionText:
        "Detaillierte Informationen zum Bike Sharing Use Case werden in K\u00fcrze verf\u00fcgbar sein.",
    },
    bikeParking: {
      heroTitle: "Intelligente Fahrradparkplätze",
    },
    webApp: {
      heroTitle: "Digitale Ökosysteme",
      heroHighlight: "In Ihrem Browser",
      components: {
        showCase: {
          features: {
            billing: {
              title: "Abrechnung",
              subtitle:
                "Integriertes Zahlungssystem für reibungslose Transaktionen",
              description:
                "Das Billing-Modul der JUHUU App ermöglicht es Nutzern, Zahlungen zu tätigen und Tarife mühelos auszuwählen. Betreiber profitieren von einer vollständigen Zahlungsinfrastruktur, die Abonnements, Einmalzahlungen und wiederkehrende Rechnungen ohne zusätzlichen Entwicklungsaufwand abwickelt. Diese integrierte Lösung reduziert den Verwaltungsaufwand für Betreiber und bietet den Nutzern gleichzeitig ein nahtloses Zahlungserlebnis direkt in der App.",
              bullets: [
                "Senkung der Betriebskosten durch automatisierte Zahlungsabwicklung",
                "Umsatzsteigerung durch flexible Preisgestaltung für Betreiber",
                "Erkenntnisse durch umfassende Finanzanalysen gewinnen",
              ],
            },
            identity: {
              title: "Identität",
              subtitle: "Sicheres Authentifizierungs- und Verifizierungssystem",
              description:
                "Das Identity-Modul der JUHUU App bietet Nutzern sichere Anmeldemöglichkeiten und Betreibern flexible Verifizierungsfunktionen. Betreiber können bei Bedarf eine Ausweisprüfung für ihre Dienste anfordern und so Sicherheit und Compliance erhöhen. Dieses vollständig integrierte Identitätsmanagementsystem vereinfacht das Onboarding und schützt sowohl Betreiber als auch Nutzer vor Betrug und unbefugtem Zugriff.",
              bullets: [
                "Reduziert Betrug und unbefugten Zugriff auf Betreiberdienste",
                "Vereinfacht Benutzerverifizierung und Compliance-Anforderungen",
                "Stärkt das Vertrauen der Kunden durch Sicherheit auf Enterprise-Niveau",
              ],
            },
            map: {
              title: "Karte",
              subtitle: "Umfassende Produkt- und Dienstesuche",
              description:
                "Die Kartenfunktion der JUHUU App zeigt alle Produkte und Dienste jedes Anbieters in einer einheitlichen Oberfläche an. So erhalten Nutzer einen vollständigen Überblick über verfügbare Optionen in ihrer Nähe und Betreiber gewinnen an Sichtbarkeit. Durch die Integration des Kartenmoduls erhalten Betreiber sofortigen Zugang zu Nutzern, die nach ähnlichen Diensten suchen, ohne eine eigene Plattform aufbauen zu müssen.",
              bullets: [
                "Mehr Sichtbarkeit für Betreiber durch Anzeige in der Nähe",
                "Erweiterte Reichweite ohne eigene Suchplattform",
                "Profitieren von JUHUUs standortbasierter Nutzergewinnung",
              ],
            },
            buddy: {
              title: "JUHUU Buddy",
              subtitle: "Mehrsprachiger KI-Assistent für Nutzer und Betreiber",
              description:
                "JUHUU Buddy ist ein integrierter KI-Assistent, der direkt in der JUHUU App verfügbar ist und Fragen zur App sowie zu den Angeboten der Betreiber beantworten kann. In 14 Sprachen verfügbar bietet er rund um die Uhr Unterstützung, ohne dass Betreiber eine eigene Support-Infrastruktur aufbauen müssen. Diese gemeinsame Ressource kommt allen Betreibern der Plattform zugute und verbessert das Nutzererlebnis.",
              bullets: [
                "Senkung der Supportkosten um bis zu 60 % für Betreiber",
                "Skalierung ohne proportionalen Personalausbau",
                "Höhere Kundenzufriedenheit durch sofortige, mehrsprachige Hilfe",
              ],
            },
            integratedBookables: {
              title: "Integrierte Buchungen",
              subtitle:
                "Vorintegrierte Dienste für ein besseres Nutzererlebnis",
              description:
                "JUHUU hat bereits wichtige Dienste wie Ladestationen (über Hubject) auf eigene Kosten integriert, sodass sie direkt in der App buchbar sind. Diese integrierten Buchungen machen die JUHUU App für Nutzer attraktiver und bieten Betreibern ein umfangreicheres Ökosystem. Durch die Teilnahme an der Plattform profitieren Betreiber von diesen bestehenden Integrationen und der wachsenden Nutzerbasis.",
              bullets: [
                "Nutzung vorhandener Integrationen wie Hubject-Ladestationen",
                "Profitieren von JUHUUs Investitionen in Drittanbieter-Anbindungen",
                "Teil eines Ökosystems mit hoher Nachfrage nach integrierten Diensten werden",
              ],
            },
          },
          learnMore: "Mehr erfahren",
          contactSales: "Vertrieb kontaktieren",
          compatibility: {
            badge: "Überall verfügbar",
            heading: "Greifen Sie von jedem Gerät oder Browser auf JUHUU zu",
            description:
              "Unsere Webplattform funktioniert nahtlos in allen modernen Browsern und auf allen Geräten, sodass Sie Ihre Mobilitätsdienste von überall aus verwalten können.",
            browserHeading: "Browser-Kompatibilität",
            browserDescription:
              "Die JUHUU WebApp läuft in allen modernen Browsern einwandfrei, ganz ohne Plugins oder Erweiterungen. Öffnen Sie einfach Ihren Browser und legen Sie los.",
            browsers: ["Chrome", "Safari", "Firefox", "Edge", "Opera"],
            deviceHeading: "Geräte-Kompatibilität",
            deviceDescription:
              "Ob Desktop, Laptop, Tablet oder Smartphone – die JUHUU WebApp passt sich Ihrer Bildschirmgröße an und bietet ein optimales Nutzererlebnis.",
            devices: [
              "Desktop",
              "Laptop",
              "Tablet",
              "iPhone",
              "Android-Geräte",
            ],
            openWebApp: "JUHUU WebApp öffnen",
            contactSales: "Vertrieb kontaktieren",
            noDownloads: "Keine Downloads oder Installationen erforderlich",
          },
        },
      },
      heroDescription:
        "JUHUU verbindet Technologie, Infrastruktur und Versorgung über unsere leistungsstarke Webplattform. Greifen Sie direkt im Browser auf das gesamte Ökosystem zu – ganz ohne Downloads. Verwalten Sie Mobilität, smarte Infrastruktur und Versorgungsleistungen von überall aus.",
      emailPlaceholder: "E-Mail-Adresse",
      getStarted: "Jetzt starten",
      webAppFeatures: [
        {
          title: "Browserbasierter Zugriff",
          description:
            "Alle Funktionen direkt im Browser nutzen – keine Softwareinstallation nötig",
        },
        {
          title: "Sichere Plattform",
          description:
            "Sicherheit auf Enterprise-Niveau mit verschlüsselten Verbindungen und Datenschutz",
        },
        {
          title: "Echtzeit-Analysen",
          description:
            "Überwachen Sie Nutzung und Performance in umfassenden Dashboards und Reports",
        },
      ],
      webPlatformTag: "Webplattform",
      webPlatformTitle: "Leistungsstarkes Mobilitätsmanagement im Browser",
      webPlatformDescription:
        "Unsere JUHUU WebApp bietet leistungsstarke Funktionen, optimiert für Desktop und Laptop. Verwalten Sie Ihr gesamtes Mobilitätsökosystem in einem Browserfenster.",
      featureCard1Title: "Plattform auf Enterprise-Niveau",
      featureCard1Description:
        "Für Skalierbarkeit und Zuverlässigkeit entwickelt – verarbeitet Millionen Transaktionen mit 99,9 % Verfügbarkeit und höchster Sicherheit.",
      featureCard1List: [
        "Hochverfügbare Architektur",
        "Verschlüsselte Datenspeicherung",
        "Regelmäßige Sicherheitsprüfungen",
      ],
      featureCard2Title: "Leistungsstarke Analysen",
      featureCard2Description:
        "Gewinnen Sie tiefe Einblicke mit umfassenden Analyse-Dashboards. Verfolgen Sie Nutzungsdaten und treffen Sie fundierte Entscheidungen.",
      featureCard2List: [
        "Echtzeit-Datenvisualisierung",
        "Individuelle Reporting-Tools",
        "Predictive Analytics",
      ],
      featureCard3Title: "Nahtlose Integration",
      featureCard3Description:
        "Anbindung an bestehende Systeme und Dienste. Unsere offene API-Architektur sichert Kompatibilität mit Ihrer Technologielandschaft.",
      featureCard3List: [
        "RESTful-API-Architektur",
        "Webhook-Unterstützung",
        "Individuelle Konnektoren",
      ],
      userExperienceTag: "Nutzererlebnis",
      bookingTitle: "Nahtloser Buchungsprozess",
      bookingDescription:
        "Von der Entdeckung bis zur Nutzung in wenigen Klicks – so einfach greifen Ihre Kunden über die JUHUU WebApp auf Ihre Services zu",
      featuresTag: "Funktionen",
      featuresTitle: "Umfassende Webplattform",
      featuresDescription:
        "Unsere JUHUU WebApp bietet ein komplettes Set an Werkzeugen zur Verwaltung von Mobilitätsdiensten, Infrastruktur und Versorgung",
      customInterfaceTag: "Anpassbare Oberfläche",
      customInterfaceTitle: "Ihre Marke, unsere Technologie",
      customInterfaceDescription:
        "JUHUU ermöglicht Organisationen, ihre Corporate Identity nahtlos in die Webplattform zu integrieren. Behalten Sie Ihre Marke und nutzen Sie unsere Technologie.",
      becomePartner: "Partner werden",
      partnerDescription:
        "Integrieren Sie Ihre Services in unser wachsendes Netzwerk",
      customInterfaces: [
        {
          title: "Individuelles Branding",
          description:
            "Organisationen können eigenes Logo, Farben und Design in die Webplattform einbinden.",
          features: [
            "Eigenes Logo integrieren",
            "Markenfarben anwenden",
            "Produktnamen anpassen",
            "Konsistentes Markenerlebnis",
          ],
        },
        {
          title: "Individuelle Tarife",
          description:
            "Flexible Tarifgestaltung und Produktkategorisierung nach Bedarf.",
          features: [
            "Eigene Tarifstrukturen",
            "Sonderrabatte und Angebote",
            "Zeit- oder nutzungsbasierte Abrechnung",
            "Flexible Preisoptionen",
          ],
        },
        {
          title: "Nahtlose Integration",
          description:
            "Vollständige Einbindung in bestehende Markenidentitäten wie ÖBB Bike.",
          features: [
            "Konsistenz mit anderen Markenkanälen",
            "Vertraute Oberfläche für Kunden",
            "Anpassbare Feature-Bezeichnungen",
            "Eigene Nutzungsbedingungen",
          ],
        },
      ],
      liveDemoTag: "Live-Demo",
      liveDemoTitle: "JUHUU WebApp in Aktion",
      liveDemoDescription:
        "Entdecken Sie verfügbare Standorte, Betreiber und Services in Echtzeit. Sehen Sie, wie einfach sich Mobilitätsdienste über unser Netzwerk buchen lassen.",
      mapHeading: "Interaktive Kartenerfahrung",
      mapDescription:
        "Durchsuchen Sie unsere interaktive Karte, um alle verfügbaren Dienste in Ihrer Nähe zu sehen. Erkunden Sie verschiedene Betreiber und Standorte an einem Ort.",
      statProviders: "Serviceanbieter",
      statBookingTime: "Durchschnittliche Buchungszeit",
      statAvailability: "Serviceverfügbarkeit",
      partners: "Bereits Partner von uns",
      joinOperator: "Betreiber werden",
      openWebApp: "JUHUU WebApp öffnen",
      viewCustomInterface: "Benutzeroberfläche ansehen",
    },
    smartCity: {
      heroTitle: "Die umfassende Smart-City-",
      heroHighlight: "Plattform",
      featuredBadge: "Hervorgehoben",
      heroHeadingMain: "Smarte Städte",
      heroHeadingHighlight: "Neu gedacht",
      heroDescription:
        "Transformieren Sie die städtische Infrastruktur zu einem einheitlichen, intelligenten Ökosystem. Stellen Sie Smart-City-Dienste mit Unternehmenszuverlässigkeit bereit, verwalten und skalieren Sie sie.",
      dashboardTitle: "Smart-City-Dashboard",
      serviceBikeParking: "Fahrradparkplätze",
      serviceBikeParkingCount: "1.247 aktiv",
      serviceEvCharging: "E-Ladestationen",
      serviceEvChargingCount: "89 Stationen",
      serviceSmartParking: "Intelligente Parkplätze",
      serviceSmartParkingCount: "2.156 Plätze",
      serviceCitizenApp: "Bürger-App",
      serviceCitizenAppCount: "45 Tsd. Nutzer",
      unifiedPlatformTitle: "Vereinheitlichte Plattform",
      unifiedPlatformSubtitle: "Alle Dienste, ein Dashboard",
      usageGrowth: "Nutzungswachstum",
      badgeEnterprise: "Unternehmensplattform",
      overviewDescription:
        "JUHUU hilft Städten, ihre urbane Mobilität und Infrastruktur zu vereinen, reduziert Integrationsaufwand und bietet nahtlose Bürgererlebnisse.",
      cityAdminTitle: "Für Stadtverwaltungen",
      cityAdminDesc:
        "Zentralisieren Sie alle vernetzten städtischen Assets – Fahrradparkplätze, Scooter-Hubs, E-Ladestationen und Parkbuchten – auf einer Plattform mit Echtzeiteinblicken und automatisierter Abrechnung.",
      cityAdminBullet: "Echtzeitverwaltung",
      innovationTeamsTitle: "Für Innovationsteams",
      innovationTeamsDesc:
        "Starten Sie neue Smart-City-Dienste in wenigen Wochen mit unserer modularen Plattform. Von Pilotprojekten bis zur stadtweiten Einführung mit vorgefertigten Integrationen.",
      innovationTeamsBullet: "Schnelle Implementierung",
      citizensTitle: "Für Bürger",
      citizensDesc:
        "Greifen Sie über eine vertraute App auf alle städtischen Dienste zu. Buchen Sie Parkplätze, entsperren Sie Fahrräder, laden Sie Fahrzeuge und bezahlen Sie nahtlos, während die Stadt wertvolle Nutzungsdaten erhält.",
      citizensBullet: "Einheitliches Erlebnis",
      processBadge: "Implementierungsprozess",
      processTitlePrefix: "Wie JUHUU",
      processTitleHighlight: "funktioniert",
      processDescription:
        "Von der ersten Beratung bis zur vollständigen Bereitstellung sorgt unser schlanker Prozess für einen erfolgreichen Start Ihrer Smart-City-Initiative.",
      step1Title: "Analyse & Planung",
      step1Desc:
        "Wir analysieren Ihre bestehende Infrastruktur, identifizieren Integrationsmöglichkeiten und erstellen eine maßgeschneiderte Roadmap für Ihre Smart-City-Transformation.",
      step1Duration: "1-2 Wochen",
      step2Title: "Pilotimplementierung",
      step2Desc:
        "Beginnen Sie mit einem gezielten Pilotprogramm, um die Lösung zu validieren, Feedback von Bürgern zu sammeln und den ROI vor einer größeren Einführung nachzuweisen.",
      step2Duration: "3-4 Wochen",
      step3Title: "Vollständige Einführung",
      step3Desc:
        "Skalieren Sie den erfolgreichen Piloten in Ihrer gesamten Stadt mit unserer bewährten Methodik, umfassenden Schulungen und laufender Unterstützung.",
      step3Duration: "3-6 Monate",
      applicationsBadge: "Plattformvorteile",
      applicationsTitlePrefix: "Warum",
      applicationsTitleHighlight: "JUHUU",
      applicationsDescription:
        "JUHUU ermöglicht erhebliche Zeitersparnis und Kostenreduktion im Vergleich zu herkömmlichen Entwicklungsansätzen.",
      feature1Title: "Zentrales Service-Management",
      feature1ImageAlt: "Zentrales Service-Management",
      centralizedPlatform: "Zentralisierte Plattform",
      centralizedPlatformDesc:
        "Verwalten Sie alle städtischen Dienste – Parken, Verkehr, Versorgung – über ein einziges Dashboard.",
      realTimeMonitoring: "Echtzeitüberwachung",
      realTimeMonitoringDesc:
        "Überwachen Sie die Serviceauslastung, erkennen Sie Engpässe und optimieren Sie die Ressourcenzuteilung mit Live-Daten.",
      feature2Title: "Nahtloses Bürgererlebnis",
      feature2ImageAlt: "Nahtloses Bürgererlebnis",
      unifiedAppAccess: "Zugriff über eine App",
      unifiedAppAccessDesc:
        "Bürger greifen über eine intuitive App auf alle Dienste – Parken, Verkehr, Zahlungen – zu.",
      personalizedServices: "Personalisierte Dienste",
      personalizedServicesDesc:
        "Passen Sie Angebote an Vorlieben, Standort und bisheriges Verhalten der Bürger an.",
      feature3Title: "Schnelle Umsetzung",
      deploymentShort: "8-12 Wochen bis zum Start",
      deploymentDesc:
        "Von der Planung bis zum Go-Live in wenigen Wochen dank unserer Implementierungsmethodik.",
      prebuiltIntegrations: "Vorgefertigte Integrationen",
      prebuiltIntegrationsDesc:
        "Binden Sie bestehende Infrastruktur mit minimalem Entwicklungsaufwand an.",
      feature4Title: "Zukunftssichere Architektur",
      openApis: "Offene APIs",
      openApisDesc:
        "Integrieren Sie einfach neue Dienste und Technologien, während sich Ihre Stadt weiterentwickelt.",
      scalableInfrastructure: "Skalierbare Infrastruktur",
      scalableInfrastructureDesc:
        "Ausgelegt für wachsende Stadtbevölkerung und erweitertes Serviceangebot.",
      caseStudiesBadge: "Erfolgsgeschichten",
      trustedBy: "Vertrauen von",
      trustedByHighlight: "führenden Städten",
      trustedByDesc: "Reale Umsetzungen in europäischen Städten",
      case1Title: "Große deutsche Stadt",
      case1Subtitle: "1.500+ Fahrradparkplätze",
      case1Desc:
        "Zentralisierte Verwaltung von über 1.500 Fahrradparkplätzen verschiedener Anbieter über die JUHUU-Plattform mit vollständiger Transparenz und Kontrolle.",
      case1Quote:
        '"JUHUU hat unser Management der Fahrradparkinfrastruktur revolutioniert. Die einheitliche Plattform bietet uns volle Transparenz über alle Anbieter."',
      case1Author: "— Mobilitätsleiter",
      case2Title: "Europäische Gemeinde",
      case2Subtitle: "800 Ständer digitalisiert",
      case2Desc:
        "800 analoge Fahrradständer mit Bluetooth-Schlössern und Echtzeitbuchung über JUHUU nachgerüstet und 45 % höhere Auslastung erzielt.",
      case2Quote:
        '"Die Nachrüstlösung war kosteneffektiv und brachte sofortige Ergebnisse. Die Bürger schätzen das nahtlose Buchungserlebnis."',
      case2Author: "— Verkehrsmanager",
    },
    pricing: {
      customInterfaces: [
        {
          title: "Individuelles Branding",
          description:
            "Anbieter können ihr eigenes Logo, Farben und Design in die App integrieren.",
          features: [
            "Eigenes Logo einbinden",
            "Markenfarben anwenden",
            "Produktnamen anpassen",
            "Konsistente Markenerfahrung",
          ],
        },
        {
          title: "Individuelle Preisgestaltung",
          description:
            "Flexible Tarifgestaltung und Produktkategorisierung nach Ihren Bedürfnissen.",
          features: [
            "Individuelle Tarifstrukturen",
            "Sonderrabatte und Angebote",
            "Zeit- oder nutzungsbasierte Abrechnung",
            "Flexible Preisoptionen",
          ],
        },
        {
          title: "Nahtlose Integration",
          description:
            "Vollständige Integration in bestehende Markenidentitäten wie ÖBB Bike.",
          features: [
            "Konsistenz mit anderen Markenkanälen",
            "Vertraute Oberfläche für Kunden",
            "Anpassbare Funktionsnamen",
            "Eigene Nutzungsbedingungen",
          ],
        },
      ],
      features: [
        {
          title: "Mobilität",
          description:
            "Umfassende Mobilitätslösungen für urbane Transportbedürfnisse.",
          benefits: [
            "Nahtlose Integration in den öffentlichen Verkehr",
            "Echtzeit-Tracking und Benachrichtigungen",
            "Flexible Zahlungsoptionen",
            "Multimodale Routenplanung",
          ],
        },
        {
          title: "Infrastruktur",
          description:
            "Intelligentes Infrastrukturmanagement für Städte und Unternehmen.",
          benefits: [
            "IoT-gestützte Überwachungssysteme",
            "Prädiktive Wartung",
            "Ressourcenoptimierung",
            "Umweltwirkung verfolgen",
          ],
        },
        {
          title: "Versorgung",
          description:
            "Effizientes Versorgungsmanagement für moderne Anforderungen.",
          benefits: [
            "Integration von Smart Metering",
            "Nutzungsanalysen und Einblicke",
            "Automatisierte Abrechnungssysteme",
            "Verbrauchsoptimierung",
          ],
        },
        {
          title: "Zahlungen",
          description:
            "Sichere und flexible Zahlungsabwicklung für alle Services.",
          benefits: [
            "Mehrere Zahlungsmethoden",
            "Abonnementverwaltung",
            "Automatisierte Rechnungsstellung",
            "Umsatzbeteiligungsfunktionen",
          ],
        },
        {
          title: "Analysen",
          description:
            "Leistungsstarke Analysetools zur Unterstützung von Geschäftsentscheidungen.",
          benefits: [
            "Dashboards in Echtzeit",
            "Individuelle Berichte",
            "Predictive Analytics",
            "Einblicke in das Nutzerverhalten",
          ],
        },
        {
          title: "Integration",
          description:
            "Nahtlose Integration in bestehende Systeme und Drittanbieterdienste.",
          benefits: [
            "Offene API-Architektur",
            "Individuelle Konnektoren",
            "Kompatibilität mit Altsystemen",
            "Plug-and-play-Module",
          ],
        },
        {
          title: "Sicherheit",
          description:
            "Sicherheit auf Enterprise-Niveau für alle Plattformkomponenten.",
          benefits: [
            "Ende-zu-Ende-Verschlüsselung",
            "Mehrfaktor-Authentifizierung",
            "Regelmäßige Sicherheitsprüfungen",
            "Einhaltung globaler Standards",
          ],
        },
      ],
    },
    useCases: {
      heroTitle: "Anwendungsfälle",
      heroDescription:
        "Entdecken Sie, wie JUHUU für verschiedene Anwendungsfälle eingesetzt werden kann, um Ihre Geschäftsziele zu erreichen.",
      designYourOwnTitle: "Eigenen Anwendungsfall gestalten",
      designYourOwnDescription:
        "Mit unserem modularen Baukastensystem digitalisieren Sie in wenigen Tagen jede Idee — vom Bike- und Scooter-Sharing bis zur smarten Parkplattform.",
      bikeParkingTitle: "Fahrradparken",
      bikeParkingDescription:
        "Unsere umfassende Bike-Parking-Lösung bietet sowohl OEMs als auch Betreibern eine komplette Verwaltungslösung mit Zugangskontrollen und Zahlungsabwicklung.",
      bikeSharingTitle: "Bikesharing",
      bikeSharingDescription:
        "Starten und verwalten Sie einen kompletten Bike-Sharing-Service mit unserer End-to-End-Lösung für Benutzer-Apps, Betreiber-Dashboards und Zahlungsabwicklung.",
      learnMore: "Mehr erfahren →",
    },
  },
  components: {
    nav: {
      products: {
        app: "App",
        appSub: "Für Endnutzer:innen",
        dashboard: "Dashboard",
        dashboardSub: "Für Betreiber:innen",
        locking: "Schließsysteme",
        lockingSub: "Hardware & Zugang",
      },
      industries: {
        bikeParking: "Fahrradparken",
        bikeRental: "Bike Rental",
        other: "Sonstige UseCases",
      },
      industriesLabel: "Branchen",
      productLabel: "Produkt",
      companyLabel: "Unternehmen",
      references: "Referenzen",
      about: "Über uns",
      bookDemo: "Demo buchen",
      getTheApp: "App laden",
    },
    siteFooter: {
      tagline:
        "Die All-in-One Plattform für die Sharing Economy — eine App, ein Dashboard, smarte Schließsysteme.",
      legalLabel: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      cookies: "Cookies",
      saasAgreement: "Globaler SaaS-Vertrag",
      termsOfService: "Globale AGB",
      cookieSettings: "Cookie-Einstellungen",
      rightsReserved: "Alle Rechte vorbehalten.",
      trademarks:
        "Apple, das Apple-Logo, iPhone und iPad sind Marken der Apple Inc., eingetragen in den USA und anderen Ländern. App Store ist eine Dienstleistungsmarke von Apple Inc. Google Play und das Google Play-Logo sind Marken von Google LLC. Alle anderen Marken sind Eigentum der jeweiligen Inhaber.",
    },
    cta: {
      ready: "Bereit, Ihr Unternehmen zu transformieren?",
      join: "Senden Sie uns gerne eine Anfrage zu. In einem persönlichen Gespräch diskutieren wir Ihre individuellen Anforderungen und wie JUHUU Ihnen helfen kann, Ihre Ziele zu erreichen.",
      launch: "Starten Sie Ihre Lösung in Wochen, nicht Monaten",
      scale: "Skalieren Sie nahtlos mit Ihrem Wachstum",
      pay: "Zahlen Sie nur für das, was Sie nutzen – dank unseres modularen Ansatzes",
      start: "Heute starten",
      fullName: "Vollständiger Name",
      workEmail: "Geschäftliche E-Mail-Adresse",
      company: "Unternehmen",
      message: "Nachricht",
      namePlaceholder: "Name eingeben",
      emailPlaceholder: "sie@unternehmen.com",
      companyPlaceholder: "Name Ihres Unternehmens",
      messagePlaceholder: "Wie k\u00f6nnen wir Ihnen helfen?",
      submit: "Vertrieb kontaktieren",
      wait: "Bitte warten...",
      sent: "Erfolgreich gesendet!",
      error: "Fehler, klicken Sie zum Wiederholen.",
      terms: "Nutzungsbedingungen",
      privacy: "Datenschutzrichtlinie",
      consent: "Mit dem Absenden dieses Formulars stimmen Sie unseren",
      and: "und",
    },
    navbar: {
      logoAlt: "JUHUU Logo",
      badgeComingSoon: "Bald verfügbar",
      buttons: {
        products: "Produkte",
        solutions: "Lösungen",
        developers: "Entwickler",
        pricing: "Preise",
        signIn: "Anmelden",
        contactSales: "Vertrieb kontaktieren",
      },
      categories: {
        core: "Kerninfrastruktur & Entwickler-Tools",
        userAccess: "Zugriff & Buchungsoberflächen",
        commerce: "Handel & Monetarisierung",
        operations: "Betrieb und Monitoring",
        customerSupport: "Kundensupport",
        comingSoonTitle: "Demnächst",
        userGroups: "Zielgruppen",
        useCases: "Use Cases",
      },
      products: {
        digitalTwins: {
          title: "Digitale Zwillinge",
          desc: "Virtuelle Abbilder",
          alt: "Digitale Zwillinge",
        },
        docs: {
          title: "Dokumentation",
          desc: "Dokumentenverwaltung",
          alt: "Dokumentation",
        },
        identity: {
          title: "Identität",
          desc: "Identitätsverwaltung",
          alt: "Identität",
        },
        plugIn: {
          title: "Plug In",
          desc: "Erweiterbare Integrationen",
          alt: "Plug In",
        },
        specialDevelopment: {
          title: "Spezialentwicklung",
          desc: "Individuelle Entwicklung",
          alt: "Spezialentwicklung",
        },
        strata: {
          title: "Strata",
          desc: "Datenanalyseplattform",
          alt: "Strata",
        },
        app: {
          title: "App",
          desc: "Mobile Anwendungen",
          alt: "App",
        },
        map: {
          title: "Karte",
          desc: "Ortsbasierte Dienste",
          alt: "Karte",
        },
        webApp: {
          title: "WebApp",
          desc: "Webanwendungsentwicklung",
          alt: "WebApp",
        },
        whitelabel: {
          title: "Whitelabel",
          desc: "White-Label-Lösungen",
          alt: "Whitelabel",
        },
        billing: {
          title: "Abrechnung",
          desc: "Rechnungsstellung",
          alt: "Abrechnung",
        },
        marketplace: {
          title: "Marketplace",
          desc: "Plattform für Anbieter",
          alt: "Marketplace",
        },
        plusSubscriptions: {
          title: "Plus-Abonnements",
          desc: "Premium-Abonnements",
          alt: "Plus-Abonnements",
        },
        revenueShare: {
          title: "Umsatzbeteiligung",
          desc: "Umsatzteilung",
          alt: "Umsatzbeteiligung",
        },
        anomalyDetection: {
          title: "Anomalieerkennung",
          desc: "Erkennung von Unregelmäßigkeiten",
          alt: "Anomalieerkennung",
        },
        dashboard: {
          title: "Dashboard",
          desc: "Geschäftsdatenvisualisierung",
          alt: "Dashboard",
        },
        advancedSupport: {
          title: "Erweiterter Support",
          desc: "Erweiterter Kundensupport",
          alt: "Erweiterter Support",
        },
        buddy: {
          title: "Buddy",
          desc: "Persönlicher Support-Assistent",
          alt: "Buddy",
        },
      },
      comingSoonList: {
        affiliateLinks: "Affiliate-Links",
        aiRouting: "KI-Routing",
        integratedBookables: "Integrierte Buchungen",
        plusSubscription: "Plus-Abonnement",
        referalLinks: "Referral-Links",
        tenderService: "Ausschreibungsdienst",
      },
      userGroups: {
        oems: "Für OEMs",
        operators: "Für Betreiber",
        users: "Für Nutzer",
      },
      useCases: {
        designYourUseCase: "Eigenen Use Case entwickeln",
        smartCity: "Smart City",
        bikeParking: "Fahrradparken",
        bikeSharing: "Bike Sharing",
        scooterSharing: "Scooter Sharing",
      },
      developers: {
        documentation: "Dokumentation",
        apiReference: "API-Referenz",
        libraries: "Bibliotheken",
      },
    },
    footer: {
      altLogo: "JUHUU Logo",
      social: {
        linkedin: "aedIn",
        youtube: "YouTube",
        instagram: "Instagram",
        facebook: "Facebook",
      },
      contactUs: "Kontaktiere uns",
      general: "Allgemeines",
      phone: "+43 660 9919 009",
      email: "office@juhuu.app",
      addressHeading: "Adresse für Meetings & Sendungen:",
      address: {
        line1: "Lassallestraße 9,",
        line2: "1020 Wien,",
        line3: "Austria",
      },
      important: "Wichtig",
      developers: "Entwickler",
      globalTerms: "Globale AGB",
      agreement: "Vereinbarung",
      globalSaas: "Globaler SaaS-Vertrag",
      privacy: "Datenschutz",
      imprint: "Impressum",
      cookiePolicy: "Cookie-Richtlinie",
      juhuuApp: "JUHUU App",
      appStoreAlt: "Im App Store herunterladen",
      googlePlayAlt: "Bei Google Play herunterladen",
      juhuuWebApp: "JUHUU WebApp",
      openWebApp: "WebApp öffnen",
      copyright:
        "© 2025 Copyright: JUHUU Bikebox GmbH. Apple, das Apple-Logo, iPhone und iPad sind Marken der Apple Inc., eingetragen in den USA und anderen Ländern. App Store ist eine Dienstleistungsmarke von Apple Inc. Google Play und das Google Play-Logo sind Marken von Google LLC. Alle anderen Marken sind Eigentum der jeweiligen Inhaber.",
      termsOfService: "Nutzungsbedingungen",
      privacyPolicy: "Datenschutzrichtlinie",
      cookieSettings: "Cookie-Einstellungen",
      sitemap: "Sitemap",
    },
    sendInquiry: {
      emailPlaceholder: "E-Mail-Adresse",
      submit: "Anfrage senden",
      wait: "Bitte warten...",
      sent: "Erfolgreich gesendet!",
      error: "Fehler, klicken Sie zum Wiederholen.",
    },
    page: {
      navItems: {
        useCases: "Anwendungsf\u00e4lle",
        app: "App",
        dashboard: "Dashboard",
        kit: "Digitalize Kit",
        marketplace: "Marketplace",
        pricing: "Preise",
      },
      close: "Schlie\u00dfen",
    },
  },
  bikeParking: {
    hero: {
      forCities: "Für Kommunen & Städte",
      description:
        "JUHUU revolutioniert das Fahrradparken in Ihrer Kommune. Unsere digitale Plattform verwandelt bestehende und neue Fahrradabstellanlagen in intelligente, umsatzgenerierende Assets – mit 70% schnellerer Einführung und bis zu 80% Kosteneinsparung.",
      emailPlaceholder: "Ihre E-Mail-Adresse",
      ctaButton: "Kostenlose Beratung",
      fastImplementation: "Schnelle Umsetzung",
      gdprCompliant: "DSGVO-konform",
      costEfficient: "Kosteneffizient",
    },
    payment: {
      magazineTitle: "Abstraction-Magazin",
      magazinePrice: "19 € pro Monat",
      applePay: "Pay",
      orCard: "Oder mit Karte bezahlen",
      emailPlaceholder: "E-Mail",
      cardDetails: "Kartendaten",
      cardNumber: "Nummer",
      expire: "MM/JJ",
      cvc: "Prüfziffer",
      countryLabel: "Land/Region",
      countryUs: "Vereinigte Staaten",
      zip: "PLZ",
      pay: "zahlen",
    },
    stats: {
      today: "Heute",
      week: "Diese Woche",
      utilization: "Auslastung",
      yesterday: "Gestern",
      now: "Heute, 14:00",
      title: "BikeParking Auslastung",
    },
    cityBenefits: {
      optimized: "Für Kommunen optimiert",
      title: "Warum Kommunen JUHUU wählen",
      description:
        "Unsere Plattform bietet Städten und Gemeinden eine einheitliche Lösung für modernes Fahrradparking",
      main: {
        unifiedTitle: "Einheitliche Bürgererfahrung",
        unifiedDesc: "Eine App für alle BikeParking-Anbieter in Ihrer Stadt",
        dataTitle: "Datengetriebene Entscheidungen",
        dataDesc: "Echtzeitdaten zur Optimierung Ihrer Fahrradinfrastruktur",
        costTitle: "Kosteneffizienz",
        costDesc: "Bis zu 80% Kosteneinsparung gegenüber Einzellösungen",
        fastTitle: "Schnelle Implementierung",
        fastDesc: "Einsatzbereit in Wochen statt Monaten",
      },
      centralLabel: "Zentrale Verwaltung",
      centralTitle: "Zentrale Verwaltung aller BikeParking-Anlagen",
      central: {
        dashboardTitle: "Zentrales Dashboard",
        dashboardDesc:
          "Verwalten Sie alle Anbieter und Standorte über eine zentrale Plattform",
        appTitle: "All-in-One App",
        appDesc:
          "Eine App für alle Fahrradpark- oder Mobilitätsservices Ihrer Stadt mit Corporate Design",
        analyticsTitle: "Umfassende Analytics",
        analyticsDesc:
          "Nutzungsstatistiken, Auslastung und Trends für bessere Stadtplanung",
        userTitle: "Automatisierte Nutzerverwaltung",
        userDesc: "Selbstständige Registrierung und Verwaltung von Nutzern",
        billingTitle: "Automatisierte Rechnungslegung",
        billingDesc:
          "Automatische Erstellung und Versand von Rechnungen an Nutzer",
        payoutTitle: "Automatisierte Auszahlungen",
        payoutDesc:
          "Regelmäßige Auszahlungen an Betreiber und Abrechnung von Provisionen",
      },
      realtimeOverlay: "Echtzeit-Übersicht",
      retrofitLabel: "Nachrüstung",
      retrofitTitle: "Bestehende Anlagen intelligent nachrüsten",
      retrofitDesc:
        "Wir können beinahe alle bestehenden Fahrradabstellanlagen einbinden – von einfachen Fahrradständern über Fahrradboxen und Sammelschließanlagen bis hin zu komplexen Fahrradtürmen. Die Integration erfolgt entweder über eine API-Schnittstelle oder durch Nachrüstung mit unserer Elektronik.",
      retrofit: {
        bluetooth: "Plug-and-Play Bluetooth Euronorm-Schlösser",
        iot: "IoT-Schließsysteme für komplexe Anlagen",
        ready: "Einsatzbereit in wenigen Tagen",
      },
      retrofitOverlay: "Einfache Installation",
      marketplaceLink: "Alle Elektroniklösungen im Marketplace entdecken",
    },
    appWebApp: {
      experienceLabel: "Nahtlose Nutzererfahrung",
      title: "Einheitliche App & WebApp für alle Bürger",
      description:
        "Bieten Sie Ihren Bürgern eine intuitive und einheitliche Nutzererfahrung für alle BikeParking-Anlagen in Ihrer Stadt",
      overlay: "Whitelabel-fähig",
      appSectionTitle: "JUHUU App",
      appSectionDesc:
        "Die JUHUU App ermöglicht Bürgern, alle BikeParking-Anlagen in Ihrer Stadt zu finden, zu buchen und zu nutzen – über eine einzige, intuitive Schnittstelle. Jeder Betreiber erhält ein individuell gestaltetes Interface innerhalb der App, sodass Nutzer sofort erkennen, wenn sie einen Ihrer Standorte nutzen.",
      internalWhiteTitle: "Internes Whitelabeling",
      internalWhiteDesc:
        "Individuelles Branding für jeden Betreiber innerhalb der App",
      bluetoothTitle: "Bluetooth-Entriegelung",
      bluetoothDesc: "Kontaktlose Entriegelung der Fahrradboxen und -ständer",
      iotTitle: "IoT-Integration",
      iotDesc: "Unterstützung für IoT-gesteuerte Schließsysteme und Sensoren",
      externalWhiteTitle: "Externes Whitelabeling",
      externalWhiteDesc:
        "Vollständig anpassbar an Ihr städtisches Corporate Design",
      moreApp: "Mehr zur JUHUU App",
      exploreWeb: "WebApp entdecken",
      webLabel: "Browser-basiert",
      webTitle: "JUHUU WebApp",
      webDesc:
        "Die browserbasierte Alternative zur JUHUU App ist standardmäßig mit dabei. Nutzer können ohne App-Download alle Standorte mit Auslastungen, Preisen usw. live sehen, diese gleich buchen und die Mobilfunk-gesteuerten Standorte auch direkt über den Browser buchen und öffnen.",
      noInstallTitle: "Keine Installation nötig",
      noInstallDesc: "Sofort nutzbar über jeden Webbrowser",
      responsiveTitle: "Responsive Design",
      responsiveDesc: "Optimiert für alle Geräte von Smartphone bis Desktop",
      availableVia: "Verfügbar über:",
      testWebApp: "WebApp testen",
      downloadTitle: "Jetzt herunterladen",
    },
    dashboard: {
      controlLabel: "Zentrale Steuerung",
      title: "Umfassendes Dashboard für Kommunen",
      description:
        "Behalten Sie den Überblick über alle BikeParking-Anlagen in Ihrer Stadt mit unserem leistungsstarken Dashboard",
      deviceTitle: "Gerätemanagement",
      deviceDesc: "Umfassende Verwaltung aller BikeParking-Geräte und -Anlagen",
      deviceBullets: [
        "Hinzufügen, Entfernen, Sperren von Geräten",
        "Übersicht über Auslastungen und Gerätestatus",
        "Fernöffnung und Wartungsmodus",
      ],
      billingTitle: "Billing",
      billingDesc: "Vollautomatisierte Abrechnung und Zahlungsabwicklung",
      billingBullets: [
        "Automatische Rechnungslegung an Nutzer",
        "Automatische Auszahlungen an Betreiber",
        "Refunds, Kautionen und Gutschriften",
      ],
      analyticsTitle: "Datenanalyse",
      analyticsDesc:
        "Umfassende Statistiken und Berichte zur Nutzung und Auslastung",
      analyticsBullets: [
        "Exportfunktion (CSV, PDF, Excel)",
        "Auslastungs- und Umsatzstatistiken",
        "Nutzerverhalten und Trends",
      ],
      tariffLabel: "Flexible Tarifsysteme",
      tariffTitle: "Maßgeschneiderte Preismodelle",
      tariffDesc:
        "Wir bieten sehr flexible Möglichkeiten für Tarife, die spezifisch jedem Standort hinzugefügt werden können. Von Pay-as-you-go über Tages-, Monats- und Jahrestarife ist alles frei einstellbar. Wir unterstützen auch die Integration von lokalen oder bundesweiten Vorteilskarten für vergünstigte Tarife.",
      tariffCards: {
        timeTitle: "Zeitbasierte Tarife",
        timeDesc: "Pay-as-you-go, Tages-, Monats-, Jahrestarife",
        companyTitle: "Unternehmensaccounts",
        companyDesc: "Kontingente für Mitarbeiter mit zentraler Abrechnung",
        familyTitle: "Familienaccounts",
        familyDesc: "Gemeinsame Nutzung für Familienmitglieder",
        benefitTitle: "Vorteilskarten",
        benefitDesc: "Integration lokaler und bundesweiter Rabattsysteme",
      },
      tariffOverlay: "Individuell anpassbar",
    },
    aiSupport: {
      label: "KI-gestützter Support",
      title: "JUHUU Buddy - Ihr intelligenter Assistent",
      description:
        "Rund um die Uhr Support für Bürger und Verwaltungsmitarbeiter mit unserem KI-gestützten Assistenten",
      chatIntro:
        "Hallo! Ich bin JUHUU Buddy, Ihr KI-Assistent für alle Fragen rund um BikeParking. Wie kann ich Ihnen heute helfen?",
      chatQuestion:
        "Ich möchte wissen, wie ich einen defekten Fahrradständer melden kann.",
      chatAnswer:
        'Sie können defekte Fahrradständer direkt über die JUHUU App melden. Öffnen Sie die App, wählen Sie den betroffenen Standort und tippen Sie auf "Problem melden". Alternativ können Sie auch den QR-Code am Standort scannen und das Problem über die WebApp melden.',
      supportTitle: "24/7 KI-gestützter Support",
      supportDesc:
        "JUHUU Buddy ist ein KI-Chatbot, der auf Ihrer gesamten Dokumentation trainiert wurde. Er ist in App, Web und Dashboard integriert und beantwortet Fragen, führt einfache Aufgaben aus und leitet bei Bedarf an menschlichen Support weiter.",
      featureEverywhereTitle: "Überall verfügbar",
      featureEverywhereDesc:
        "Integriert in App, WebApp und Dashboard für nahtlosen Support",
      featureAlwaysTitle: "24/7 Verfügbarkeit",
      featureAlwaysDesc:
        "Rund um die Uhr Support ohne Wartezeiten für Ihre Nutzer",
      featureTasksTitle: "Automatisierte Aufgaben",
      featureTasksDesc:
        "Führt einfache Aufgaben wie Standortsuche oder Statusabfragen aus",
      featureLanguagesTitle: "Mehrsprachig",
      featureLanguagesDesc:
        "Unterstützt mehrere Sprachen für internationale Besucher",
      learnMore: "Mehr über KI-Support erfahren",
      requestDemo: "Demo anfordern",
      statAnswered: "der Anfragen automatisch beantwortet",
      statAvailability: "Verfügbarkeit ohne Wartezeiten",
      statCost: "Reduzierung der Support-Kosten",
    },
    hardware: {
      ecosystemLabel: "Hardware-Ökosystem",
      title: "Unsere Hardware-Partner",
      description:
        "JUHUU arbeitet mit führenden Herstellern zusammen, um Ihnen die beste Hardware-Auswahl zu bieten",
      marketplaceButton: "Alle Partner im Marketplace entdecken",
      independentLabel: "Herstellerunabhängig",
      independentTitle: "Herstellerunabhängige Integration",
      independentDesc:
        "JUHUU funktioniert mit Hardware aller führenden Hersteller. Unsere offene Plattform ermöglicht es Ihnen, die beste Hardware für Ihre spezifischen Anforderungen zu wählen, ohne an einen Anbieter gebunden zu sein.",
      independentBullets: [
        "Autarke Bluetooth-Schließsysteme ohne externe Stromversorgung",
        "Mobilfunk-Anbindung von Steuerungen und Sensoren",
        "Solar-betriebene Systeme",
        "Nachrüst-Module für bestehende Anlagen",
      ],
    },
    pricingSection: {
      heading: "PREISE",
      decorativeAlt: "Dekoratives Hintergrundbild",
      heroStart: "Entfalte",
      heroHighlight1: "grenzenlose Möglichkeiten",
      heroMid: "mit",
      heroHighlight2: "nutzungsbasierter",
      heroEnd: "Abrechnung",
      description:
        "Keine Vorabkosten, keine versteckten Gebühren – nur transparente Preise, die mit deinem Erfolg wachsen. Du zahlst nur für das, was du nutzt, wann du es nutzt.",
      deviceTypes: {
        iot: {
          name: "IoT-Geräte",
          description:
            "Geräte mit von JUHUU bereitgestellter SIM-Karte. Dazu gehören Smart Locks, Parksensoren und andere vernetzte Hardware, die Mobilfunk benötigt.",
        },
        online: {
          name: "Online-Geräte",
          description:
            "Drittgeräte mit eigener Konnektivität wie Partner-Hardware oder bestehende Infrastruktur, die du bereits besitzt.",
        },
        offline: {
          name: "Offline-Geräte",
          description:
            "Stellplätze ohne direkte Steuerung wie Fahrradräume oder Parkplätze, die über die JUHUU-Plattform verwaltet werden.",
        },
        bluetooth: {
          name: "Bluetooth-Geräte",
          description:
            "Standard-Bluetooth-Geräte von JUHUU wie Schlösser, Beacons und andere Hardware mit Bluetooth-Kommunikation.",
        },
      },
      deviceLicenseTitle: "Monatliche Geräte-Lizenz",
      deviceInfo:
        "Es werden nur aktive Geräte berechnet. Mengenrabatte werden automatisch angewendet.",
      table: {
        volume: "Menge",
        price: "Preis",
        savings: "Ersparnis",
        save: "Spare {{savings}}%",
        basePrice: "Grundpreis",
      },
      includedProducts: "Enthaltene Produkte:",
      modules: {
        app: "JUHUU App",
        webapp: "JUHUU Web App",
        dashboard: "JUHUU Dashboard",
        marketplace: "JUHUU Marketplace",
        map: "JUHUU Map",
        docs: "JUHUU Docs",
        billing: "JUHUU Billing Engine",
      },
      hideExplanation: "Geräteerklärung ausblenden",
      showExplanation: "So funktioniert die Geräteabrechnung",
      explanationTitle: "So funktioniert die Geräteabrechnung",
      explanationIntro:
        "Unsere Preise richten sich nach den tatsächlich betriebenen Geräten und Stellplätzen:",
      explanationPoints: {
        iot: "Monatliche Gebühr für jedes Gerät mit JUHUU-SIM (z.B. 10 Fahrradboxen = 10 Gerätekosten)",
        offline:
          "Für Stellplätze ohne direkte Steuerung (z.B. Fahrradraum mit 100 Plätzen: IoT-Gebühr pro Schloss plus Offline-Gebühr pro Platz)",
        online:
          "Für Drittgeräte mit eigener Konnektivität (zusätzliche Herstellergebühren möglich)",
        bluetooth: "Für von JUHUU bereitgestellte Standard-Bluetooth-Geräte",
      },
      volumeDiscount:
        "Mengenrabatte richten sich nach der Gesamtzahl der Geräte in deiner Flotte, nicht pro Standort.",
      transactionTitle: "Buchungsprovision",
      transactionInfo:
        "Provision auf jede über JUHUU abgewickelte Buchung. Du zahlst nur, wenn du verdienst.",
      payOnlyLabel: "Zahle nur für tatsächliche Buchungen",
      payOnlyText: "Provision wird nur bei erfolgreicher Buchung fällig.",
      examples: "Beispiele:",
      booking: "Buchung",
      fee: "Gebühr: {{amount}}",
      feeMax: "Gebühr: {{amount}} (max.)",
      premiumTitle: "Premium-Services",
      premiumDesc:
        "Zusätzlich buchbare Services zur Erweiterung deines Angebots",
      comingSoon: "BALD VERFÜGBAR",
      premiumServices: {
        buddy: {
          name: "JUHUU Buddy",
          description:
            "KI-gestützter Assistent für Nutzer und Betreiber mit natürlicher Sprachverarbeitung.",
          pricing: "Nutzungsbasiert",
          pricingDetails: "Abrechnung pro Token",
        },
        identity: {
          name: "Identitätsprüfung",
          description:
            "Sichere Identitätsprüfung für Nutzer mit Dokumentenscan und biometrischer Kontrolle.",
          pricing: "€2",
          pricingDetails: "/Verifizierung",
        },
        support: {
          name: "Erweiterter Kundensupport",
          description:
            "Premium-Support mit persönlichem Ansprechpartner und bevorzugten Antwortzeiten.",
          pricing: "€300-500",
          pricingDetails: "/Betreiber + Token-Nutzung",
        },
        maintenance: {
          name: "Predictive Maintenance",
          description:
            "KI-gestützte Anomalieerkennung und vorausschauende Wartung für deine Geräteflotte.",
          pricing: "€1",
          perDevice: "/Gerät",
          pricingDetails: "+ Token-Nutzung",
        },
      },
      calculatorTitle: "Preisrechner",
      calculatorDesc:
        "Schätze deine monatlichen Kosten basierend auf deinen Anforderungen",
      simulatorTitle: "JUHUU Preis-Simulator",
      configuration: "Deine Konfiguration",
      deviceTypesTitle: "Gerätearten",
      monthlyTransactions: "Monatliche Buchungen",
      numberOfBookings: "Anzahl der Buchungen",
      commissionPerBooking: "10% Provision pro Buchung",
      avgBookingValue: "Durchschnittlicher Buchungswert (€)",
      minMaxFee: "Min. Gebühr: 0,50 €, max. 5 €",
      estimatedTitle: "Geschätzte Monatskosten",
      deviceLicenses: "Gerätelizenzen",
      devicesTotal: "Geräte gesamt",
      transactionCommissions: "Buchungsprovisionen",
      totalMonthlyCost: "Gesamtkosten pro Monat",
      estimateDisclaimer:
        "Diese Berechnung basiert auf deinen Angaben. Die tatsächlichen Kosten können je nach Nutzung, Mengenrabatten und anderen Faktoren variieren. Kontaktiere unser Vertriebsteam für ein detailliertes Angebot.",
      contactSales: "Vertrieb für detailliertes Angebot kontaktieren",
      note: 'JUHUU behält sich vor, künftig separate Gebühren für zusätzliche Produkte einzuführen. Alle Module, die nicht unter "Premium-Plugins/Produkte" aufgeführt sind, sind derzeit durch Geräte-Lizenzen und Buchungsprovisionen abgedeckt.',
    },
  },
} as const;
